// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* card */

.card {
    border: 1px solid #EEEEEE;
    display: flex;
    flex-direction: column;
    min-width: 0;
    background-color: #fff;
    background-clip: border-box;
    box-shadow: 0 2px 1px rgba(0, 0, 0, 0.05);
    border-radius: 0.27rem;
}

.card + .card {
    margin-top: 1rem;
}

.card.raised {
    box-shadow: 0 10px 18px 0 rgba(62, 57, 107, 0.2);
}

.card .card-header {
    padding: 1rem;
}

.card .card-header h1, .card .card-header h2, .card .card-header h3, .card .card-header h4, .card .card-header h5, .card .card-header h6 {
    margin: auto;
    flex: 1;
}

.card .card-header .button-container {
    margin: auto;
}

.card .card-header .btn:not(.btn-lg) {
    padding: .25rem 1rem;
    font-size: .75rem;
}

.card .card-header img {
    margin: auto;
}

.card .card-header .labeled-divider {
    margin-bottom: 0;
}

.card .card-main {
    padding: 1rem;
}

.card .card-footer {
    padding: 1rem;
}

/* labeled divider */

.labeled-divider {
    margin: 2rem 0;
    line-height: 0.1rem;
    border-bottom: 1px solid #dadada;
    text-align: center;
    font-size: .8rem;
    color: #6F7274;
}

.labeled-divider span {
    background-color: #fff;
    padding: .75rem;
}

.dinning-table {
    user-select: none;
}

.dinning-table:hover .resize-handle {
    display: block;
}

.resize-handle {
    display: none;
}

/* buttons */
h1 .btn,
h2 .btn,
h3 .btn,
h4 .btn,
h5 .btn,
h6 .btn,
.card .card-header h1 .btn,
.card .card-header h2 .btn,
.card .card-header h3 .btn,
.card .card-header h4 .btn,
.card .card-header h5 .btn,
.card .card-header h6 .btn {
    padding: 0;
    font-size: 1.25rem;
}

.btn {
    border: 1px solid transparent;
    padding: 0.75rem 1rem;
    font-size: 1rem;
    line-height: 1.25;
    border-radius: 0.21rem;
    white-space: nowrap;
}

.btn:focus {
    outline: none;
}

.btn-lg {
    padding: 1rem 1.25rem;
    font-size: 1.1rem;
    line-height: 1.25;
    border-radius: 0.27rem;
}

.btn-sm {
    padding: .25rem .3rem;
    font-size: .75rem;
    border-radius: 0.15rem;
    min-height: 2rem;
}

.btn-xl {
    padding: 1rem 1.25rem;
    font-size: 2rem;
    line-height: 1.25;
    border-radius: 0.27rem;
}

.btn:not(:disabled):not(.disabled):not([disabled]) {
    cursor: pointer;
}

.btn:disabled,
.btn.disabled,
.btn[disabled] {
    cursor: not-allowed;
}

.btn-full-width {
    display: block;
    width: 100%;
}

.btn-primary {
    /*
        border-color: #03A9F4;
        background-color: #03A9F4;
    */
    border-color: #005377;
    background-color: #005377;
    color: #FFFFFF;
}

.btn-secondary {
    border-color: #3A4856;
    background-color: #3A4856;
    color: #fff;
}

.btn-white {
    color: #fff;
}

.btn-danger {
    border-color: #DA4453;
    background-color: #DA4453;
    color: #FFFFFF;
}

.btn.btn-icon {
    line-height: 1;
    border: none;
    background: transparent;
    padding: 0;
}

.btn.btn-icon.btn-secondary {
    color: #3A4856;
}

.btn.btn-icon.btn-primary {
    color: #3A4856;
}

.btn.btn-icon.btn-danger {
    color: #DA4453;
}

.btna.btn-icon.btn-secondary * {
    vertical-align: middle;
}

.btn .btn-content {
    display: inline-flex;
    margin: auto;
}

.btn:not(.btn-icon) .btn-content > i:first-of-type {
    margin-left: .5rem;
}

.btn:not(.btn-icon) .btn-content > span {
    padding-left: .5rem;
    padding-right: .5rem;
}

.btn.btn-icon:not(.btn-no-inner-margin) .btn-content > span + i {
    margin-left: .5rem;
}

.btn.btn-icon:not(.btn-no-inner-margin) .btn-content > i + span {
    margin-left: .5rem;
}

.btn-group .btn:not(:last-of-type) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.btn-group .btn + .btn {
    margin-left: -1px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 1px solid #ccc;
}

.btn-group .btn {
    opacity: .5;
}

.btn-group .btn.active, .btn-group .btn:not(.disabled):hover {
    opacity: 1;
}

.btn-group .btn-primary + .btn-primary {
    border-left-color: #ededed;
}

.btn-group .btn-sm {
    padding: .25rem 1rem;
}

.btn-icon-stacked {
    text-align: center;
}

.btn.btn-icon.btn-icon-stacked .btn-content i:first-of-type,
.btn.btn-icon.btn-icon-stacked .btn-content i:last-of-type,
.btn.btn-icon.btn-icon-stacked .btn-content i + span {
    margin-left: 0;
    margin-right: 0;
}

.btn-icon-stacked + btn-icon-stacked {
    margin-left: .5rem;
}

.btn-icon-stacked .btn-content {
    display: block;
}

.btn-icon-stacked .btn-content span {
    display: block;
}

.btn.btn-link {
    padding: 0;
    border: none;
    background-color: transparent;
}

.btn.btn-link .btn-content i + span {
    margin-left: .5rem;
}

.btn.btn-link .btn-content > span {
    padding-left: 0;
    padding-right: 0;
}

.floating-label .btn-show-password {
    position: absolute;
    top: 1rem;
    right: 1rem;
}

.stacked-label .btn-show-password {
    position: absolute;
    right: 1.75rem;
    top: 1.75rem;
}

.loading-placeholder.button {
    height : 2.875rem;
    display: inline-block;
    width  : 8rem;
    margin : 0.375rem;
}

.modal-footer .btn .ti-trash {
    font-size: 1.5rem;
}


.terms-and-conditions-container {
    margin-top: 1rem;
    padding: .5rem;
    border: 1px solid #ededed;
    height: 10rem;
    overflow-y: auto;
    background-color: #fff;
    font-size: .75rem;
    margin-bottom: 1rem;
}

.email-report-message-textarea textarea {
    height: 250px;
}

/* anchors */

a {
    /* color: #3BAFDA; */
    color: #005377;
    text-decoration: none;
    cursor: pointer;
}

a.disabled, a[disabled],
button.disabled, button[disabled] {
    opacity: .5;
    cursor: default;
}


/* Alerts */

.alert {
    padding: 1rem;
    margin-bottom: 1.5rem;
    border: 1px solid transparent;
    border-radius: .25rem;
    text-align: center;
}

.alert.alert-danger {
    color: #a94442;
    background-color: #f2dede;
    border-color: #ebccd1;
}

.alert.alert-success {
    border: 1px solid #566787;
    background-color: #8495b7;
    color: white;
}

/* table */

table.table {
    border-spacing: 0px;
}

table thead tr th a {
    width: 100%;
    cursor: pointer;
    display: inline-block;
    color: #55595c;
}

table thead tr th a i {
    margin-left: 0.625rem;
}

.table-header .records-per-page-wrapper span {
    margin: auto;
}

.table-header .records-per-page-wrapper select {
    margin: auto .5rem auto 0;
    width: 4rem;
}

.table-header input, .table-header select {
    height: 2.125rem;
    border-radius: 0.1875rem;
    border-color: #ddd;
    box-shadow: none;
}

.table-header select.input-field:not([size]):not([multiple]) {
    height: 2.125rem;
}

.table-header {
    display: flex;
    justify-content: space-between;
    padding: 0;
    font-size: .85rem;
}

.table-header .btn {
    height: 2.125rem;
}

.table-header label {
    font-weight: normal;
    margin-left: 0.625rem;
}

.table-header select, .table-header input {
    display: inline-block;
    margin:0;
}

.table-header input {
    width: 12.5rem;
    display: inline-block;
}

table.table td div {
    display: inline-block;
}

table.table tr td.table-row-sub-head {
    border-bottom: 1px solid #CDCDCD;
    padding-bottom: 3px;
    padding-top: 1rem;
    color: #777;
}

table .fit-content {
    width:1%;
    white-space:nowrap;
}

table tr.selected td {
    background-color: #CDCDCD;
}

.filter-group {
    display: flex;
    margin: auto 0;
    white-space: nowrap;

    width: 100%;
    flex-direction: column;
}

.filter-group label {
    margin: auto 0;
}

.filter-group .form-control {
    flex: 1;
}

.filter-group select.form-control {
    width: 6.875rem;
}

.filter-icon {
    float: right;
    margin-top: 0.4375rem;
}

.filter-icon i {
    font-size: 1.125rem;
    opacity: 0.7;
}

table.table {
    border-right-width: 0;
    border-top-width: 0;
    width: 100%;
    border-left: 1px solid #C2CCD6;
    border-bottom: 1px solid #C2CCD6;
}

table.table.no-border {
    border:none;
}

table.table tr td {
    border-top: 1px solid #C2CCD6;
    border-bottom-width: 0;
    border-left-width: 0;
}


table.table.no-border tr td {
    border: none;
}

table.table tr.deleting td {
    text-decoration: line-through;
    color: #ccc;
}

table.table tr.deleting td a,
table.table tr.deleting td button {
    text-decoration: line-through;
    color: #ccc;
}

table.table thead th {
    text-transform: uppercase;
    background-color: #fff;
    border-top: 1px solid #C2CCD6;
    border-bottom: 1px solid #C2CCD6;
}

table.table thead th a {
    padding: 0;
}

table.table thead th .btn {
    font-size: 0.85rem;
}

table.table.no-border thead th {
    border-top: none;
    border-right: none;
}

table.table tr th, table.table tr td {
    padding: .5rem 0.9375rem;
    vertical-align: middle;
    font-size: .9rem;
    border-right: 1px solid #C2CCD6;
}

.table-hover tbody tr.loading:hover {
    background-color: transparent;
}

table.table-striped tbody:nth-of-type(even) {
    background-color: #F3F5F7;
}

table.table-striped tbody tr.loading:nth-of-type(even):hover {
    background-color: #f5f5f5;
}

table.table-striped.table-hover tbody:hover {
    background: #f5f5f5;
}

table tr.deleting td {
    color: #ccc;
    text-decoration: line-through;
}

table tr td .loading-placeholder {
    width: 100%;
    margin: 0.3rem 0 0.3rem 0;
}

table.table.table-small tr th,
table.table.table-small tr td {
    padding: .25rem .9375rem;
}

table .expanded-content {
    display: none;
}

table .expanded-content.active {
    display: table-row;
}

table .expand-cell {
    cursor: pointer;
}

.record-not-found-state, .empty-state {
    text-align: center;
    padding: 1.25rem;
}

.record-not-found-state i, .empty-state i {
    font-size: 5rem;
    display: inline-block;
    margin-bottom: 1.25rem;
}

.record-not-found-state b, .empty-state b {
    display: inline-block;
    font-size: 1.25rem;
    margin-bottom: 0.5rem;
}

.table-pager-row + table.table {
    margin-top: 1rem;
}

.table-pager-row {
    margin-top: .5rem;
    display: flex;
    justify-content: space-between;
    flex-direction: column-reverse;
}

.table-header + .tag-wrapper {
    margin-top: .5rem;
}

table .button-column-spacer {
    width: 4rem;
}

table.modal-table {
    width: 100%;
    border-collapse: collapse;
}

table.modal-table th {
    font-weight: bold;
    padding: .5rem;
    border-bottom: 2px solid #333;
}

table.modal-table td {
    padding: .5rem;
}

.record-count {
    margin: auto 0;
    margin-top: 1rem;
    text-align: center;
    font-size: 0.85rem;
    margin-bottom: 1rem;
}

.record-count .loading-placeholder {
    width: 6rem;
}

.pagination {
    flex: 1;
    display: flex;
    justify-content: space-between;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
}

.pagination .btn {
    flex: 1;
    margin: auto .25rem auto 0;
    padding: .5rem 0;
}

.pagination .btn:not(:first-of-type) {
    margin-left: .25rem;
}

.pagination .btn:last-of-type {
    margin-right: 0;
}

.page-item.disabled .page-link {
    opacity: .25;
    cursor: default;
}

.pagination {
    margin: auto 0;
    flex: 0;
}

.pagination .loading-placeholder {
    width: 3rem;
    margin-left: 1rem;
    min-height: 1rem;
    margin-top: 0.4375rem;
    margin-bottom: 0.4375rem;
}

.pagination li a {
    border: none;
    font-size: 0.8125rem;
    min-width: 1.875rem;
    min-height: 1.875rem;
    border-radius: 0.125rem !important;
    text-align: center;
    padding: 0 0.375rem;
    display: block;
    color: #999;
}

.pagination .page-item:not(:disabled):not(.disabled):hover {
    background-color: #e9ecef;
}

.pagination li a:hover {
    color: #666;
}

.pagination li.active a {
    /*
    background: #03A9F4;
    */
    background:#005377;
    color: #fff;
}

.pagination li.active a.page-link:hover {
    background: #0397d6;
}

.pagination li.disabled i {
    color: #ccc;
}

.pagination li i {
    font-size: 1rem;
    padding-top: 0.375rem
}

.pagination .page-link:focus {
    box-shadow: none;
}

.pagination .page-link i {
    display: none;
}

@media (min-width: 575px) {
    .form-container .checkbox.inline-checkbox {
        margin-top: 2.5625rem;
        margin-bottom: .75rem;
    }
}

@media (min-width: 768px) {
    .table-header .records-per-page-wrapper {
        display: flex;
    }
    .table-header .records-per-page-wrapper select {
        margin: auto .5rem auto .5rem;
        width: unset;
    }

    .table-header .filter-group input, .table-header .filter-group select {
        margin-left: 0.3125rem;
    }

    .filter-group {
        flex: 1;
        max-width: 24rem;
        width: 100%;
        flex-direction: row;
    }
    .table-pager-row {
        flex-direction: row;
    }
    .record-count {
        margin-top: auto;
        margin-bottom: auto;
    }

    .modal-container.small .modal-content {
        width:50%;
        height: 60%;
    }

    .modal-container .modal-content {
        width: 75%;
        max-width: 60rem;
        margin: auto;
        height: 85%;
    }

    .modal-content .content {
        height: calc(100% - 4rem);
        overflow: hidden auto;
        background: #f3f3f3;
    }

    .modal-content .content.has-footer {
        height: calc(100% - 9rem);
    }

    .modal-content .modal-footer {
        border-top: 1px solid #e0e0e0;
    }
}


/* Forms */
.form-container h4 {
    margin-bottom: 0;
}

.form-container .input-field {
    margin-top: 1rem;
    font-size: .9rem;
    position: relative;
}

.form-container .input-field:last-of-type {
    margin-bottom: 1rem;
}

.form-container+.form-container {
    margin-top: 1rem;
}

.form-footer {
    display: flex;
    padding-top: 1rem;
    padding-bottom: 1rem;
}

.form-footer > * {
    margin: auto;
}

.form-footer .btn-container {
    flex: 1;
    text-align: right;
}

.btn + .btn {
    margin-left: .5rem;
}

.has-badge {
    position: relative;
}

.has-badge .button-badge {
    background: #DA4453;
    color: #333;
    font-weight: bold;
    padding: 3px;
    border-radius: 15px;
    display: inline-block;
    width: auto;
    min-width: 15px;
    font-size: 10px;
    position: absolute;
    top: -5px;
    right: -5px;
}

/* inputs */

/* Remove controls from Firefox */
input[type=number] {
    -moz-appearance: textfield;
}

/* Remove controls from Safari and Chrome */
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0; /* Removes leftover margin */
}

.input-field.digit-field input {
    padding: 0.5rem;
    width: 3rem;
    text-align: center;
}

.input-field.field-fit-content input,
.input-field.field-fit-content select {
    width: fit-content;
}

.input-field.text-right input {
    text-align: right;
}

.input-field.floating-label {
    position: relative;
}

.input-field.floating-label label {
    position: absolute;
    background-color: white;
    padding: 0 .25rem;
}
.input-field.floating-label label span.invalid {
    margin-left: 1rem;
}

.input-field.floating-label.input-lg .icon-wrapper {
    left: 0rem;
    position: absolute;
    top: 0rem;
    padding-top: 1rem;
    width: 3.5rem;
    display: flex;
}

.input-field.floating-label.input-lg .icon-wrapper i {
    margin: auto;
}

.input-field.floating-label label.active {
    font-size: .75rem;
}

.input-field.floating-label.input-lg label.active {
    top: -0.6rem;
}

.input-field.floating-label.input-lg label {
    top: .75rem;
    left: 1rem;
}

.input-field.floating-label.icon-field.input-lg label {
    left: 3.5rem;
}

.input-field.floating-label.icon-field.input-lg label.active {
    left: .5rem;
}

.input-field:not(.radio) input, .input-field select, .input-field textarea {
    border: 1px solid #d4d4d4;
    width: 100%;
    padding-left: .5rem;
    padding-right: .5rem;
    border-radius: 0.22rem;
    padding: .5rem;
    background-color: #fff;
    font-size: 1rem;
}

@media (max-width: 575px) {
    .input-field:not(.radio) input, .input-field select, .input-field textarea {
        padding-top: .25rem;
        padding-bottom: .25rem;
    }
}

.input-field:not(.radio) input, .input-field select {
    height: 2.05rem;
}

.input-field.input-lg input {
    height: 3rem;
    padding: 0.75rem;
    font-size: 1.1rem;
    line-height: 1.45;
    border-radius: 0.27rem;
}

.input-field.input-sm input, .input-field.input-sm select {
    padding: .2rem;
    height: 1.75rem;
}

.input-field.input-xs input, .input-field.input-xs select {
    padding: .1rem;
    height: 1.5rem;
}

.input-field.input-xs-long input, .input-field.input-xs-long select {
    padding: .1rem;
    height: 1.5rem;
    width: 15rem;
}

.input-field.icon-field input {
    padding-right: 1.25rem;
    padding-left: calc(3.375rem + 2px);
}

.input-field input:focus, .input-field textarea:focus {
    color: #4E5154;
    border-color: #3BAFDA;
    outline: 0;
}

.input-field input.invalid, .input-field select.invalid, .input-field textarea.invalid {
    border-color: red;
}

.input-field input + span.invalid, .input-field select + span.invalid, .input-field textarea + span.invalid{
    height: 0;
    display: block;
}

.invalid {
    color: red;
}



.inline-label.input-field, .inline-label .input-field {
    display: flex;
}

.inline-label.input-field input:not(.radio), .inline-label .input-field input:not(.radio) {
    flex: 1;
}

.inline-label label, .inline-label .input-field label {
    margin: auto .25rem auto 0;
}

.inline-label label span.invalid,
.inline-label .input-field label span.invalid {
    right: .15rem;
    position: absolute;
}

@media (min-width: 576px) {
    .grid-container .input-field[class^='sm-'].inline-label label span.invalid,
    .grid-container .input-field[class*=' sm-'].inline-label label span.invalid {
        right: 1.15rem;
    }
}

.placeholder-label {
    position: absolute;
    font-size: 75%;
}

.bold-label label {
    font-weight: bold;
}

.input-field.no-label label {
    display: none;
}

.stacked-label.input-field {
    display: flex;
    flex-direction: column;
    text-align: left;
}

.stacked-label.input-field span.invalid {
    text-align: right;
}

.form-container .section-header {
    border-bottom: 1px solid #55595c;
    margin-top: 2rem;
}

.form-container .checkbox {
    margin-top: 1rem;
}

.checkbox label {
    display: flex;
    font-size: .9rem;
    width: fit-content;
}

.checkbox:not(.label-right) label input {
    margin: auto auto auto .5rem;
}

.checkbox.label-right label input {
    margin: auto .5rem auto auto;
}

.checkbox.no-label label span.label {
    display: none;
}

.checkbox.no-label label input {
    margin-left: auto;
}

.checkbox .label.right-label {
    display: none;
}

.checkbox.label-right .label.left-label {
    display: none;
}

.checkbox.label-right .label.right-label {
    display: inline;
}

@media (min-width: 575px) {
    .checkbox.sm-4:nth-of-type(2) label {
        margin-left: auto;
        margin-right: auto;
    }

    .checkbox.sm-4:nth-of-type(3) label {
        margin-left: auto;
    }
}

.toggle-switch-wrapper {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 21px;
    margin-left: .5rem;
}

.toggle-switch-wrapper input.toggle-switch {
    opacity: 0;
    width: 0;
    height: 0;
}

.toggle-switch-wrapper .toggle-switch-slider {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: 0.3s;
    cursor: pointer;
    background: #AAA;
    border-radius: 30px;
}

.toggle-switch-wrapper .toggle-switch-slider:before {
    position: absolute;
    content: "";
    height: 17px;
    width: 17px;
    left: 3px;
    bottom: 2.6px;
    background-color: #fff;
    border-radius: 50%;
    transition: 0.3s;
    top: 2px;
}

.toggle-switch-wrapper input:checked + .toggle-switch-slider {
    background-color: #005377;
}

.toggle-switch-wrapper input:checked + .toggle-switch-slider:before {
    transform: translateX(18px);
}

.toggle-switch-wrapper .toggle-switch-label {
    position: absolute;
    left: 100%;
    width: max-content;
    line-height: 30px;
    cursor: pointer;
}

.input-field .loading-placeholder {
    display      : block;
    border-radius: 0.25rem;
    height       : 0.6rem;
}

.input-field label.loading-placeholder {
    width: 6.25rem;
}

.input-field .text-input.loading-placeholder {
    height: 2rem;
    margin: 0;
    top   : 0.25rem;
    width: 100%;
}

.search-field:not(.no-label) .input-field label,
.input-field:not(.radio):not(.search-input-field):not(.no-label) label {
    display: flex;
    white-space: nowrap;
}

.search-field-wrapper {
    position: relative;
}

.clear-search-button {
    position: absolute;
    right: .5rem;
    opacity: 0.6;
}

.clear-search-button:hover {
    opacity: 1;
}

hr {
    border: .0625rem solid #005377;
    border-radius: .25rem;
    opacity: 0.25;
}


/* Badges */

.badge {
    padding: .1rem .25rem .1rem .25rem;
    border-radius: 10rem;
    color: #fff;
    position: absolute;
    right: -.25rem;
    top: .25rem;
    font-size: .75rem;
}

.badge-container {
    position: relative;
}


.badge.badge-primary {
    /*
    background-color: #03A9F4;
    */
    background-color: #005377;
}

.badge.badge-secondary {
    background-color: #3A4856;
}

.badge.badge-danger {
    background-color: #DA4453;
}




/* placeholders */
.loading-placeholder {
    display      : block;
    border-radius: 0.25rem;
    height       : 0.6rem;
}


.card .shimmer, table .shimmer{
    background       : #F5F5F6;
    background-image : linear-gradient(to right, #F5F5F6 0%, #fff 20%, #F5F5F6 80%, #F5F5F6 100%);
    background-repeat: no-repeat;
    background-size  : 800px 100%;
    display          : inline-block;
    position         : relative;

    animation-duration       : 1.5s;
    animation-fill-mode      : forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;

    -webkit-animation-duration       : 1.5s;
    -webkit-animation-fill-mode      : forwards;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-timing-function: linear;
}

.shimmer {
    background       : #e0e0e0;
    background-image : linear-gradient(to right, #e0e0e0 0%, #ededed 20%, #e0e0e0 80%, #e0e0e0 100%);
    background-repeat: no-repeat;
    background-size  : 800px 100%;
    display          : inline-block;
    position         : relative;

    animation-duration       : 1.5s;
    animation-fill-mode      : forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;

    -webkit-animation-duration       : 1.5s;
    -webkit-animation-fill-mode      : forwards;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-timing-function: linear;
}

.shimmer:first-of-type {
    animation-name        : placeholderShimmer;
    -webkit-animation-name: placeholderShimmer;
}

@keyframes placeholderShimmer{
    0% {
        background-position: -800px 0;
      }

      100% {
        background-position: 100vw 0;
      }
}

 @-webkit-keyframes placeholderShimmer {
   0% {
     background-position: -800px 0;
   }

   100% {
     background-position: 100vw 0;
   }
 }


 /* Data List */
 .data-list-wrapper .loading-placeholder {
    width: 100%;
    height: 3rem;
    margin-bottom: 1rem;
 }

 ul.data-list {
     padding: 0;
     border: 1px solid #E0E0E0;
 }

 ul.data-list > li {
     padding:.5rem;
     list-style: none;
     background-color: #EEEEEE;
     position: relative;
 }

 ul.data-list > li a.btn-edit-data-item {
    position: absolute;
    top: 0;
    right: 2rem;
 }

 ul.data-list > li a.btn-remove-data-item {
     position: absolute;
     top: .25rem;
     right: .5rem;
     padding: 0;
 }

 ul.data-list > li.deleting a.btn-remove-data-item,
 ul.data-list > li.deleting a.btn-remove-data-item * {
    text-decoration: none;
    color: #005377;
 }

 .deleting *:not(.no-line-through){
    color: #ccc !important;
    text-decoration: line-through;
 }

 ul.data-list > li.deleting > *:not(.no-line-through) {
    color: #ccc;
    text-decoration: line-through;
 }

 .no-line-through, .no-line-through * {
     text-decoration: none !important;
 }

 ul.data-list > li.deleting input,
 ul.data-list > li.deleting select {
     color: #ccc;
     text-decoration: line-through;
 }

 ul.data-list > li:nth-child(odd) {
    background-color: #FFF;
}

.data-list > li a + a {
    margin-left: .5rem;
}

ul.data-list > li > .input-field:first-of-type {
    margin-top:0;
}

.collapsable-button {
    padding: 0;
}

.collapsable-button.active i {
    transform: rotate(90deg);
}

.collapsable-button.btn:not(.btn-icon) .btn-content > i:first-of-type {
    margin-left: 0;
}

.collapsable {
    display: none;
}

.collapsable.active {
    display: block;
}

.dropdown-wrapper {
    position: relative;
}

.modal-content > header .dropdown-nav a:first-of-type i {
    font-size: 1rem;
}

.dropdown-nav > .btn {
    font-size: 1.25rem;
}

.dropdown-nav.white > .btn {
    color: #fff;
}

.full-width .dropdown {
    width: 100%;
}

.dropdown {
    display: none;
    list-style: none;
    position: absolute;
    background-color: #fff;
    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, .08);
    box-shadow: 0 2px 4px rgba(0, 0, 0, .08);
    margin: 0;
    padding: 0;
    border-top: 1px solid #f6f6f6;
    z-index: 1000;
    font-size: 1rem;
}

.dropdown ul {
    list-style: none;
}

.dropdown-nav.align-right .dropdown {
    right: 0;
}

.dropdown.open {
    display: block;
}

.dropdown li a {
    display: block;
    display: block;
    min-width:10rem;
    padding: .5rem 1rem;
    color: #3A4856;
    font-size: 1rem;
}

.dropdown li p {
    padding: .5rem 1rem;
}

.page-nav li.seperator-top,
.dropdown li.seperator-top {
    border-top: 1px solid #ccc;
}


/* Modal */
.modal-container .modal-content {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
    z-index: 1003;
    overflow-y: auto;
}

.modal-content > header {
    background: #005377;
    height: 4rem;
    display: flex;
    padding: 0 1.25rem;
    color: white;
}

.modal-content > header a:first-of-type i {
    margin-top: auto;
    margin-bottom: auto;
    font-size: 2rem;
}

.modal-content > header > span {
    flex: 1;
    margin: auto;
    font-size: 1.5rem;
}

.modal-content .content.has-footer {
    min-height: calc(100% - 9rem);
}

.modal-content .modal-footer {
    padding: 1rem;
    display: flex;
}

.modal-content .modal-footer .btn-container {
    margin-left: auto;
}

.modal-container .modal-background {
    opacity: .7 !important;
    background-color: black;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 1002;
}

.modal-container .confirmation-prompt {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding-top: 0;
}


.modal-container .confirmation-prompt h4 {
    background: #005377;
    height: 4rem;
    display: flex;
    padding: 0 1.25rem;
    color: white;
    font-size: 1.5rem;
    margin: 0 -1rem;
    line-height: 4rem;
}

.tag-wrapper {
    margin: -.25rem .5rem -.25rem 0;
    font-size: .75rem;
    display: flex;
    flex-wrap: wrap;
}

.tag-heading {
    white-space: nowrap;
    margin-top: auto;
    margin-bottom: auto;
}

.tag {
    margin: .25rem 0 .25rem .5rem;
    background-color: #55595c;
    color: white;
    padding: .3rem .4rem;
    border-radius: .3rem;
    white-space: nowrap;
    display: flex;
}

.btn-remove-tag {
    margin-left: auto;
    font-size: .75rem;
    color: red;
    font-weight: bold;
    padding: 0;
}

/*
.btn-remove-tag {
    margin-left: .25rem; may not need at all
}
*/
.tag .btn-remove-tag .btn-content > span {
    padding-right: 0;
}


/* RIGHT SLIDER */
.slider-background {
    opacity: .7;
    background-color: black;
}

.right-slider {
    position: fixed;
    right: -24rem;
    top: 4rem;
    background-color: #fff;
    width: 20rem;
    z-index: 1000;
    bottom: 0;
    transition: right 0.5s;
    -webkit-transition: right 0.5s;
}

.right-slider .slider-content-wrapper {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    display: flex;
    flex-direction: column;
}

.right-slider .slider-content {
    padding: 1rem;
    bottom: 5rem;
    width: 20rem;
    flex: 1;
    overflow-y: auto;
}

.right-slider .slider-footer {
    width: 100%;
    padding: 1rem;
}

.right-slider .slider-footer .btn {
    width: 100%;
}

.right-slider.active {
    right: 0;
}

.btn-slide-closer {
    font-weight: bolder;
    font-size: 1.5rem;
    color: #55595c;
    position: absolute;
    top: 0;
    right: 20rem;
    background-color: #fff;
    padding: .5rem .75rem;
    border-radius: 0 0 0 .5rem;
}

@media (min-width: 1025px) {
    .slider-background {
        display: none !important;
    }
}


.customer-search {
    position: relative;
}

.btn-create-customer .btn-content {
    background-color: white;
}

.input-field + .search-field {
    margin-top: 1rem;
}

.search-field {
    position: relative;
}

.search-dropdown-header-container {
    padding:.5rem .5rem .25rem 1rem;
    border-bottom: 1px solid #efefef;
    margin-bottom: .5rem;
}

.search-dropdown .search-results {
    max-height: 29rem;
    overflow: auto;
}

.search-dropdown .search-results .disabled {
    color: #ccc;
}

.search-field.no-label label {
    display: none;
}

.search-field .input-field {
    margin-top: 0;
}

.search-field span.invalid {
    font-size: .8rem;
}

.search-field.active input {
    border-bottom: 1px solid #eee;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}

.search-field.invalid:not(.active) input {
    border-color: red;
}

.search-field .search-dropdown {
    font-size: .75rem;
    display: none;
    background-color: #fff;
    border: 1px solid #3BAFDA;
    border-bottom: 1px solid #eee;
    border-bottom-right-radius: 0.22rem;
    border-bottom-left-radius: 0.22rem;
    position: absolute;
    width: 100%;
    z-index: 1001;
    top: 2rem;
}

.search-field:not(.no-label):not(.inline-label) .search-dropdown {
    top: calc(3rem + 4px);
}

.search-field.no-label .search-dropdown {
    border-top: 1px solid #ccc;
}

.grid-container .search-field .search-dropdown {
    width: calc(100% - 2rem);
}

.search-field.active .search-dropdown {
    display: block;
}

.search-field.focused .search-dropdown {
    border-top-color: #DEDEDE;
    border-right-color: #3BAFDA;
    border-bottom-color: #3BAFDA;
    border-left-color: #3BAFDA;
}

.search-field.invalid .search-dropdown {
    border-right-color: red;
    border-bottom-color: red;
    border-left-color: red;
}

.search-field.focused input {
    border-right-color: #3BAFDA;
    border-top-color: #3BAFDA;
    border-bottom-color: #3BAFDA;
    border-left-color: #3BAFDA;
}

.search-field.focused.invalid input {
    border-right-color: red;
    border-top-color: red;
    border-left-color: red;
}

.search-field .selected-results {
    padding: 1rem;
    font-size: .75rem;
}

.search-field .search-results ul {
    margin: 0;
    padding: 0;
}

.search-field .searching-label {
    position: absolute;
    right: 1rem;
    top: 1.5rem;
    z-index: 1002;
}

.grid-container .search-field .searching-label {
    right: 2rem;
}

.search-field .search-results ul li {
    padding: .5rem;
    list-style: none;
    cursor: pointer;
    color: #3A4856;
}

.search-field .search-results ul li:first-of-type {
    padding-top: 1rem;
}

.search-field .search-results ul li i {
    margin-right: .5rem;
    opacity: 0;
    color: green;
}

.search-field .search-results ul li.selected {
    font-weight: bold;
}

.search-field .search-results ul li.selected i {
    opacity: 1;
}

.search-field-wrapper {
    display:  flex;
}

.search-field-wrapper .search-field {
    flex: 1;
}

.search-field-wrapper .btn {
    height: 31.5px;
    margin-top: 2.25rem;
    margin-left: .5rem;
}

.width-100.search-field>.input-field {
    width: 100%;
}

.user-profile-image-field {
    text-align: center;
}

.user-profile-image-field .image-outer-wrapper {
    position: relative;
    max-width: 13rem;
    margin: auto;
}

.user-profile-image-field .image-wrapper {
    max-width: 13rem;
    overflow: hidden;
}

.user-profile-image-field .profile-image {
    height: 13rem;
    font-size: 10rem;
}

.user-profile-image-field .croppie-wrapper {
    width: 100%;
}

.user-profile-image-field .croppie-wrapper .croppie-container .cr-boundary {
    height: 13rem;
}

.user-profile-image-field .croppie-wrapper .croppie-container .cr-slider-wrap {
    margin-top: .25rem;
    margin-bottom: 0;
}

.user-profile-image-field .btn-remove-data-item {
    padding: 0;
    top: -.5rem;
    right: -.5rem;
    position: absolute;
}

.image-container {
    margin-top: .5rem;
    display: flex;
    flex-direction: column;
    text-align: center;
    min-height: 15rem;
    position: relative;
}

.image-container img {
    width: 100%;
    margin-bottom: auto;
}

.image-container.deleted img {
    opacity: .25;
}

.image-container .btn-remove-data-item {
    top: 0rem;
    right: 0rem;
    position: absolute;
    padding: 0;
}


/* Image Carousel */
.image-carousel {
    display: flex;
    flex-direction: column;
    height: 100%
}

.image-carousel .active-image {
    flex: 1;
    margin: auto;
    width: 100%;
    display: flex;
}

.image-carousel .active-image .nav {
    display: flex;
    width: 5%;
    height: 10rem;
    margin: auto 0rem;
}

.image-carousel .active-image .nav .btn-nav {
    font-size: 2rem;
    height: 100%;
    width: 100%;
    display: flex;
    color: #3A4856;
}


.image-carousel .active-image .nav .btn-nav i {
    margin: auto;
}

.image-carousel .active-image .image-wrapper {
    flex: 1;
    display: flex;
    margin: auto 0;
}

.image-carousel .active-image img {
    margin: auto auto;
    max-width: 90%;
    width: auto;
    max-height: calc(100vh - 25rem);
    height: auto;
    display: block;
}

.image-carousel-thumbnails {
    display: flex;
    justify-content: center;
}

.image-carousel-thumbnails img {
    height: 4rem;
    margin: .25rem;
}


/* Inventory Scheduler */
.scheduler-timeline {
    overflow-x: hidden;
}

.inventory-scheduler-row-wrapper {
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    margin-top: .25rem;
    height: 2.5rem;
}

.scheduler-month-wrapper:first-of-type .inventory-scheduler-row-wrapper {
    border-left: 1px solid #ccc;
}

.scheduler-month-wrapper:last-of-type .inventory-scheduler-row-wrapper {
    border-right: 1px solid #ccc;
}

.inventory-scheduler-item-block {
    border-left: 1px solid #ededed;
    margin-right: -1px;
    position: relative;
}

.scheduler-month-wrapper:first-of-type .inventory-scheduler-row-wrapper .inventory-scheduler-item-block:first-of-type {
    border: none;
}

.pre-event {
    background-color: #ccc;
    border-color: transparent;
    background-image:
        repeating-linear-gradient(-45deg, black, #ddd 1px, transparent 1px, transparent 5px);
}

.event {
    background-color: #ccc;
    border-color: transparent;
}

.scheduler-event-info {
    position: absolute;
    white-space: nowrap;
    top: .7rem;
    left: .25rem;
    font-weight: bold;
    font-size: 85%;
    z-index: 100;
}

.scheduler-event-info .btn {
    text-decoration: underline;
    color: #55595c;
    font-size: .65rem;
}

.post-event {
    background-color: #ccc;
    border-color: transparent;
    background-image:
        repeating-linear-gradient(45deg, black, #ddd 1px, transparent 1px, transparent 5px);
}

.conflict {
    background-color: red;
    border-left-color: transparent;
}

.inventory-scheduler-request-header {
    height: 2.5rem;
    margin-top: .25rem;
}

.inventory-scheduler-request-header b {
    margin: auto;
}

.inventory-scheduler-item-header .inventory-item-selction-check {
    margin-left: -2rem;
}

.inventory-scheduler-item-header {
    height: 2.5rem;
    margin-top: .25rem;
    padding-left: .5rem;
    white-space: nowrap;
}

.inventory-scheduler-item-header .btn {
    font-size: .8rem;
}

.inventory-scheduler-top-row {
    height: 2.75rem;
}

.inventory-scheduler-vertical-spacer {
    padding: .25rem;
    text-align: center;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
}

.inventory-scheduler-vertical-spacer-header {
    color: white;
    background-color: #55595c;
}

.inventory-scheduler-empty-row i {
    margin:auto;
}

.page-nav {
    padding: 0 0 1rem 0;
    margin: 0;
    height: min-content;
}

.page-nav li {
    list-style: none;
}

.page-nav li a {
    padding: .5rem 1rem;
}

.confirmation-prompt {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 4rem;
    padding: 4rem 1rem 0 1rem;
    z-index: 900;
    background: #f3f3f3;
}

.confirmation-prompt ~ * {
    display: none;
}

@media (min-width: 1025px) {
    .confirmation-prompt {
        left: 16rem;
    }
}

.page-heading {
    display: flex;
    margin-bottom: 1rem;
}

.page-heading h1,
.page-heading h2,
.page-heading h3,
.page-heading h4,
.page-heading h5,
.page-heading h6 {
    margin: 0;
}

.page-heading .btn-container,
.page-heading .btn-container,
.page-heading .btn-container,
.page-heading .btn-container,
.page-heading .btn-container,
.page-heading .btn-container {
    margin-left: auto;
    display: flex;
}


.date-field-calendar {
    position: absolute;
    background-color: #fff;
    padding: .5rem;
    width: 100%;
    border: 1px solid #005377;
    top: 3.25rem;
    z-index: 1;
    min-width: 16rem;
}

.date-field-calendar-header {
    display: flex;
    padding: .5rem 1rem;
}

.date-field-calendar-header-center {
    text-align: center;
    flex: 1;
}

.date-field-calendar-body {
    display: flex;
    flex-direction: column;
    margin-top: .5rem;
}

.date-field-calendar-row {
    flex: 1;
    display: flex;
}

.date-field-calendar-row:first-of-type {
    font-weight: bold;
}

.date-field-calendar-day {
    flex: 1;
    padding: .25rem;
    text-align: center;
}

.date-field-calendar-footer {
    padding: .5rem .5rem .25rem .5rem;
    border-top: 1px solid #efefef;
    margin-top: 0.5rem;
    text-align: center;
}

.date-field-calendar-footer .btn {
    font-size: .75rem;
}

@media (min-width: 768px) {

    .form-container .input-field,
    .checkbox label {
        font-size: .8rem;
    }

    .input-field:not(.radio) input, .input-field select, .input-field textarea {
        font-size: .9rem;
    }

    .date-field-calendar {
        max-width: 25rem;
    }
}

@media (min-width: 575px) {
    .sm-1 > .date-field-calendar,
    .sm-2 > .date-field-calendar,
    .sm-3 > .date-field-calendar,
    .sm-4 > .date-field-calendar,
    .sm-5 > .date-field-calendar,
    .sm-6 > .date-field-calendar,
    .sm-7 > .date-field-calendar,
    .sm-8 > .date-field-calendar,
    .sm-9 > .date-field-calendar,
    .sm-10 > .date-field-calendar,
    .sm-11 > .date-field-calendar,
    .sm-12 > .date-field-calendar {
        width: calc(100% - 2rem);
    }
}

@media (min-width: 768px) {
    .md-1 > .date-field-calendar,
    .md-2 > .date-field-calendar,
    .md-3 > .date-field-calendar,
    .md-4 > .date-field-calendar,
    .md-5 > .date-field-calendar,
    .md-6 > .date-field-calendar,
    .md-7 > .date-field-calendar,
    .md-8 > .date-field-calendar,
    .md-9 > .date-field-calendar,
    .md-10 > .date-field-calendar,
    .md-11 > .date-field-calendar,
    .md-12 > .date-field-calendar {
        width: calc(100% - 2rem);
    }
}

@media (min-width: 992px) {
    .lg-1 > .date-field-calendar,
    .lg-2 > .date-field-calendar,
    .lg-3 > .date-field-calendar,
    .lg-4 > .date-field-calendar,
    .lg-5 > .date-field-calendar,
    .lg-6 > .date-field-calendar,
    .lg-7 > .date-field-calendar,
    .lg-8 > .date-field-calendar,
    .lg-9 > .date-field-calendar,
    .lg-10 > .date-field-calendar,
    .lg-11 > .date-field-calendar,
    .lg-12 > .date-field-calendar {
        width: calc(100% - 2rem);
    }
}

@media (min-width: 1200px) {
    .xl-1 > .date-field-calendar,
    .xl-2 > .date-field-calendar,
    .xl-3 > .date-field-calendar,
    .xl-4 > .date-field-calendar,
    .xl-5 > .date-field-calendar,
    .xl-6 > .date-field-calendar,
    .xl-7 > .date-field-calendar,
    .xl-8 > .date-field-calendar,
    .xl-9 > .date-field-calendar,
    .xl-10 > .date-field-calendar,
    .xl-11 > .date-field-calendar,
    .xl-12 > .date-field-calendar {
        width: calc(100% - 2rem);
    }
}


.user-profile-image {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
}

i.user-avatar {
    font-size: 2.5rem;
}

img.user-avatar {
    width: 2.5rem;
    height: 2.5rem;
}


.loader, .loader:before, .loader:after {
    background: transparent;
    -webkit-animation: load1 1s infinite ease-in-out;
    animation: load1 1s infinite ease-in-out;
    width: .5rem;
    height: 4rem;
}

.loader {
    color: #ddd;
    font-size: .5rem;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
}

.loader:before, .loader:after {
    position: absolute;
    top: 0;
    content: '';
}

.loader:before {
    left: -1.5em;
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
}

.loader:after {
    left: 1.5em;
}

.rich-text-editor {
    background-color: #FFF;
    border: 1px solid #d4d4d4;
    width: 100%;
    padding: .5rem;
    border-radius: .22rem;
    height: 15rem;
    overflow: auto;
}

.rich-text-editor:focus {
    color: #4E5154;
    border-color: #3BAFDA;
    outline: none;
}

.settings-terms-field .rich-text-editor {
    height: 35rem;
}

@-webkit-keyframes load1 {
  0%, 80%, 100% {
    box-shadow: 0 0;
    height: 4em;
  }
  40% {
        box-shadow: 0 -2em;
        height: 5em;
    }
}
@keyframes load1 {
    0%, 80%, 100% {
        box-shadow: 0 0;
        height: 4em;
    }
    40% {
        box-shadow: 0 -2em;
        height: 5em;
    }
}


.header-logo-image-preview {
    height: 4rem;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 13rem auto;
}

.interactive-room-assigner {
    font-size: 85%;
}

.interactive-room-assigner .time-column .time-slot > span {
    padding: 0 .5rem;
    margin: auto;
}

.interactive-room-assigner .time-column .time-slot:not(first-of-type),
.interactive-room-assigner .venue .time-slot:not(first-of-type) {
    border-top: 1px solid #CCC;
    height: 48px;
    display: flex;
}

.interactive-room-assigner .venue {
    border-left: 1px solid;
    flex: 1;
    position: relative;
}

.interactive-room-assigner .venue .time-slot {
    background-color: #fff;
}

.interactive-room-assigner .time-column .header,
.interactive-room-assigner .venue .header {
    font-weight: bold;
    height: 32px;
    border-bottom: 1px solid #333;
    display: flex;
}

.interactive-room-assigner .time-column .header > span,
.interactive-room-assigner .venue .header > span {
    margin: auto;
}
.interactive-room-assigner .time-column .header.invert,
.interactive-room-assigner .venue .header.invert {
    background: #333;
    color: #fff;
}

.interactive-room-assigner .venue.hover .time-slot {
    background: #ededed;
}

.interactive-room-assigner .meeting {
    background: #005377;
    color: white;
    cursor: move;
    width: calc(100% - 2px);
    position: absolute;
    padding: 0 .25rem;
    overflow: visible;
    margin: 0 1px;
    border-top: 1px solid #fff;
}

.interactive-room-assigner .meeting .meeting-label {
    overflow: hidden;
}

.interactive-room-assigner .meeting a {
    color: white;
    font-size: .75rem;
}

.interactive-room-assigner .meeting .meeting-detail-container {
    position: relative;
}

.interactive-room-assigner .meeting .meeting-detail {
    position: absolute;
    bottom: .25rem;
    border: 1px solid #333;
    background: #fff;
    color: #333;
    padding: 1rem;
    min-width: 26rem;
    right: -.25rem;
    z-index: 1000;
}

.interactive-room-assigner .meeting .meeting-detail.open-right {
    left: -.25rem;
    right: unset;
}

.interactive-room-assigner .meeting .meeting-detail a {
    color: #333;;
}

.interactive-room-assigner .meeting.working {
    background: #EE964B;
}

.interactive-room-assigner .meeting.time-slot-1 {
    top: calc(2rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-2 {
    top: calc(3.5rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-3 {
    top: calc(5rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-4 {
    top: calc(6.5rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-5 {
    top: calc(8rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-6 {
    top: calc(9.5rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-7 {
    top: calc(11rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-8 {
    top: calc(12.5rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-9 {
    top: calc(14rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-10 {
    top: calc(15.5rem + 2px);
}

.interactive-room-assigner .meeting.time-slot-11 {
    top: calc(17rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-12 {
    top: calc(18.5rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-13 {
    top: calc(20rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-14 {
    top: calc(21.5rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-15 {
    top: calc(23rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-16 {
    top: calc(24.5rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-17 {
    top: calc(26rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-18 {
    top: calc(27.5rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-19 {
    top: calc(29rem + 2px);
}

.interactive-room-assigner .meeting.time-slot-20 {
    top: calc(30.5rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-21 {
    top: calc(32rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-22 {
    top: calc(33.5rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-23 {
    top: calc(35rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-24 {
    top: calc(36.5rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-25 {
    top: calc(38rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-26 {
    top: calc(39.5rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-27 {
    top: calc(41rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-28 {
    top: calc(42.5rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-29 {
    top: calc(44rem + 2px);
}

.interactive-room-assigner .meeting.time-slot-30 {
    top: calc(45.5rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-31 {
    top: calc(47rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-32 {
    top: calc(48.5rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-33 {
    top: calc(50rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-34 {
    top: calc(51.5rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-35 {
    top: calc(53rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-36 {
    top: calc(54.5rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-37 {
    top: calc(56rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-38 {
    top: calc(57.5rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-39 {
    top: calc(59rem + 2px);
}

.interactive-room-assigner .meeting.time-slot-40 {
    top: calc(60.5rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-41 {
    top: calc(62rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-42 {
    top: calc(63.5rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-43 {
    top: calc(65rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-44 {
    top: calc(66.5rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-45 {
    top: calc(68rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-46 {
    top: calc(69.5rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-47 {
    top: calc(71rem + 2px);
}
.interactive-room-assigner .meeting.time-slot-48 {
    top: calc(72.5rem + 2px);
}

.interactive-room-assigner .meeting.time-slot-count-1 {
    height: calc(1.5rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-2 {
    height: calc(3rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-3 {
    height: calc(4.5rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-4 {
    height: calc(6rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-5 {
    height: calc(7.5rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-6 {
    height: calc(9rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-7 {
    height: calc(10.5rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-8 {
    height: calc(12rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-9 {
    height: calc(13.5rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-10 {
    height: calc(15rem - 3px);
}

.interactive-room-assigner .meeting.time-slot-count-11 {
    height: calc(16.5rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-12 {
    height: calc(18rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-13 {
    height: calc(19.5rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-14 {
    height: calc(21rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-15 {
    height: calc(22.5rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-16 {
    height: calc(24rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-17 {
    height: calc(25.5rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-18 {
    height: calc(27rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-19 {
    height: calc(28.5rem - 3px);
}

.interactive-room-assigner .meeting.time-slot-count-20 {
    height: calc(30rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-21 {
    height: calc(31.5rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-22 {
    height: calc(33rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-23 {
    height: calc(34.5rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-24 {
    height: calc(36rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-25 {
    height: calc(37.5rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-26 {
    height: calc(39rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-27 {
    height: calc(41.5rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-28 {
    height: calc(42rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-29 {
    height: calc(43.5rem - 3px);
}

.interactive-room-assigner .meeting.time-slot-count-30 {
    height: calc(45rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-31 {
    height: calc(46.5rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-32 {
    height: calc(48rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-33 {
    height: calc(49.5rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-34 {
    height: calc(51rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-35 {
    height: calc(52.5rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-36 {
    height: calc(54rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-37 {
    height: calc(55.5rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-38 {
    height: calc(57rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-39 {
    height: calc(58.5rem - 3px);
}

.interactive-room-assigner .meeting.time-slot-count-40 {
    height: calc(60rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-41 {
    height: calc(61.5rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-42 {
    height: calc(63rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-43 {
    height: calc(64.5rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-44 {
    height: calc(66rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-45 {
    height: calc(67.5rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-46 {
    height: calc(69rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-47 {
    height: calc(70.5rem - 3px);
}
.interactive-room-assigner .meeting.time-slot-count-48 {
    height: calc(72rem - 3px);
}

.bold-label {
    color: #005377;
    font-weight: bold;
}

.input-field.rich-editor-template-placeholder-select {
    margin-bottom: 1rem;
}

.input-field.rich-editor-template-placeholder-select label {
    white-space: initial;
}

.blank-wrapper {
    width: 100%;
}

.display-page-wrapper {
    width: 100%;
    height: 100%;
}

.meeting-placard {
    background-image: url(./img/meetingPlacardBackground.jpg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 100%;
    padding: 1rem;
    color: #fff;
    display: flex;
    flex-direction: column;
}

.meeting-placard hr {
    border: .15rem solid #fff;
    opacity: 1;
    border-radius: 0;
    color: #fff;
    background-color: #fff;
}

.meeting-placard .venue-name {
    font-size: 2rem;
    text-align: center;
}

.meeting-placard .next-meeting-info {
    text-align: right;
    font-size: 2rem;
}

.meeting-placard .meeting-data {
    font-size: 4em;
    text-align: center;
    margin-top: auto;
    margin-bottom: auto;
}

.meeting-placard .meeting-data .meeting-number {
    font-size: 4rem;
}

.meeting-placard .meeting-data .meeting-time {
    margin-top: .5rem;
    font-size: 2.25rem;
}

.meeting-placard .meeting-data .meeting-name {
    margin-top: .5rem;
    font-size: 3rem;
}

.meeting-display {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.display-page-wrapper .meeting-display-header {
    background: #00004c;
    color: white;
    display: flex;
    padding: .5rem;
}

.display-page-wrapper .meeting-display-header > div {
    flex: 1;
    font-size: 2.25rem;
}

.display-page-wrapper .meeting-display-header > span {
    margin-top: auto;
    margin-bottom: auto;
}


.display-page-wrapper .meeting-display-content {
    height: 100%;
    display: flex;
}

.display-page-wrapper .meeting-display-header .meeting-display-time {
    font-size: 2rem;
    margin-left: .5rem;
}

.display-page-wrapper .meeting-display-content .meeting-display-list {
    background: #333;
    color: white;
    height: 100%;
    padding: 0 .5rem .5rem .5rem;
    border-top: 1px solid white;
    width: 30rem;
    min-width: 30rem;
}

.display-page-wrapper .meeting-display-content .meeting-display-list.full {
    width: 100%;
}

.display-page-wrapper .meeting-display-content .meeting-display-list table {
    border-spacing: 0;
    width: 100%;
}

.display-page-wrapper .meeting-display-content .meeting-display-list table td,
.display-page-wrapper .meeting-display-content .meeting-display-list table th {
    padding: .5rem .5rem;
}

.display-page-wrapper .meeting-display-content .meeting-display-list table thead {
    border-bottom: 2px solid white;
}

.display-page-wrapper .meeting-display-content .meeting-display-list table thead th {
    border-bottom: 2px solid white;
    text-align: center;
}

.display-page-wrapper .meeting-display-content .meeting-display-list table thead th:last-of-type {
    text-align: left;
}

.display-page-wrapper .meeting-display-content .meeting-display-list table thead td:not(:last-of-type) {
    border-bottom: 2px solid #ccc;
    text-align: center;
}

.display-page-wrapper .meeting-display-content .meeting-display-grid {
    overflow-x: auto;
}

.display-page-wrapper .meeting-display-content .meeting-display-grid table {
    height: 100%;
    border-spacing: 0;
}

.display-page-wrapper .meeting-display-content .meeting-display-grid th,
.display-page-wrapper .meeting-display-content .meeting-display-grid td {
    border: 1px solid #ccc;
}

.display-page-wrapper .meeting-display-content .meeting-display-grid .meeting-display-grid-time {
    width: 100px;
    min-width: 100px;
    text-align: center;
    padding: .5rem;
}

.display-page-wrapper .meeting-display-content .meeting-display-grid .meeting-container-cell {
    position: relative;
}

.display-page-wrapper .meeting-display-content .meeting-display-grid .meeting-block {
    display: flex;
    background: #333;
    border: 1px solid white;
    border-radius: .5rem;
    position: absolute;
    color: white;
    top: 0;
    bottom: 0;
}


.pickup-label {
    font-size: 0.7rem;
    padding: 0 4px;
    color: #666;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.display-page-wrapper .meeting-display-content .meeting-display-grid .meeting-block > span {
    margin: auto;
}

.report-page .datagrid .datagrid-header {
    display: flex;
    font-weight: bold;
    border-bottom: 2px solid #333;
    height: 25px;
}

.report-page .datagrid .datagrid-header .datagrid-report-time-cell {
    border: none;
}

.report-page .datagrid .datagrid-content {
    display: flex;
}

.report-page .datagrid .datagrid-content .datagrid-report-time-cell-column {
    width: 50px;
    page-break-after: always;
}

.report-page .datagrid .datagrid-header .datagrid-column-header {
    font-weight: bold;
    flex: 1;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
 }

.report-page .datagrid .datagrid-report-time-cell {
    padding: 0;
    width: 50px;
    border: 1px solid #CCC;
    border-top: none;
    display: flex;
}

.report-page .datagrid .datagrid-report-time-cell span {
    margin: auto;
}

.report-page .datagrid-report-items-column {
    position: relative;
    min-width: 150px;
    padding: 0;
    box-sizing: content-box;
    vertical-align: top;
    flex: 1;
    border-right: 1px solid #ccc;
}

.report-page .datagrid-report-items-column .datagrid-report-items-cell {
    border-bottom: 1px solid #ddd;
    width: 100%;
    display: block;
}

.report-page .datagrid-report-items-column .datagrid-report-item {
    display: flex;
    text-align: center;
    position: absolute;
    background: #CCC;
    width: 100%;
    border: 1px solid white;
    border-right: none;
    border-left: none;
    overflow: hidden;
}

.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content * {
    font-size: 10px !important;
}

.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content .datagrid-report-item-inner-content {
    margin: auto 0;
    max-height: 100%;
    padding: 2px 0;
    display: flex;
    flex-direction: column;
}

.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content .meeting-name {

}

.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content .meeting-details {
    text-align: center;
    width: 100%;
    padding: 3px 0;
}

/* small */
.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content.small {
    line-height: 1;
}

.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content.small * {
    font-size: 9px !important;
}

.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content.small .meeting-name {
    overflow: hidden;
}

/* x-small */
.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content.x-small {
    line-height: 1;
}

.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content.x-small .datagrid-report-item-inner-content {
    padding: 0;
}

.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content.x-small * {
    font-size: 8px !important;
}

.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content.x-small .meeting-name {
    overflow: hidden;
}

.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content.x-small .meeting-details {
    padding: 0;
}


.report-page .profile-pic {
    font-size: 3rem !important;
    height: 3rem !important;
}

.note-disclaimer {
    bottom: 5rem;
    left: 0;
    position: absolute;
    padding: 1rem;
}

.cost-management-factor-breakdown .heading {
    background-color: #337357;
    font-weight: bold;
    text-align: center;
    color: white;
}

.cost-management-factor-breakdown .factor-breakdown-row > div {
    border: 1px solid #AAA;
    padding: 0 .25rem;
}

.non-removable-attendee-info + .non-removable-attendee-info {
    padding-top: 1rem;
    margin-top: 1rem;
    border-top: 1px solid #AAA;
}

.video-button {
    height: 1.5rem;
    margin-top: auto;
    margin-bottom: auto;
    margin-right: .5rem;
    cursor: pointer;
}

.help-document-button {
    height: 1.5rem;
    margin-top: auto;
    margin-bottom: auto;
    margin-right: .5rem;
}

.modal-video {
    margin: auto;
    width: 100%;
    aspect-ratio: 16/9;
    display: block;
}

.badging-table {
    max-width: 40rem;
}

.PhoneInputCountry {
    width: 4.5rem;
}

.PhoneInputCountryIcon {
    box-shadow: none;
}

.PhoneInputCountryIcon > .country-selection-icon-wrapper {
    position: relative;
    width: 4.5rem;
}

.PhoneInputCountryIcon > .country-selection-icon-wrapper > img {
    position: absolute;
    top: -0.25rem;
    width: 2rem;
}

.PhoneInputCountryIcon > .country-selection-icon-wrapper > span {
    position: absolute;
    top: -0.2rem;
    right: 0;
}

.PhoneInputCountrySelectArrow {
    margin-left: 1rem;
}

.editable-meeting-detail .modal-content .content {
    height: calc(100% - 9rem);
    overflow: auto;
}



/* Meeting Detail Modal */
.editable-meeting-detail .modal-content .content {
    padding: .5rem;
    height: calc(100% - 14rem);
    overflow: auto;
    min-height: unset;
    overflow-x: hidden;
}

.readonly-meeting-detail .modal-content {
    background-color: #ECECEC;
}

.readonly-meeting-detail .modal-content .content {
    padding: .5rem;
    height: calc(100% - 14rem);
    overflow: auto;
    min-height: unset;
    overflow-x: hidden;
}

.readonly-meeting-detail-section {
    font-family: "Muli", Georgia, "Times New Roman", Times, serif;
    background-color: #fefefe;
    padding: .25rem;
    font-weight: bold;
}

.readonly-meeting-detail-section + .readonly-meeting-detail-label {
    margin-top: .5rem;
}

.readonly-meeting-detail .readonly-meeting-detail-label {
    font-size: .85rem;
    font-weight: normal;
    font-style: italic;
    color: #005377;
}

.readonly-meeting-detail-section .readonly-meeting-detail-heading {
    font-weight: normal;
    margin-bottom: .5rem;
}

.readonly-meeting-detail-section i {
    font-weight: normal;
}

.footer-tab-bar {
    background: #005377;
    height: 5rem;
    padding: 0;
    display: flex;
    color: white;
    justify-content: space-around;
    flex: 1;
}

.footer-tab-bar > .dropdown-nav {
    margin-top: auto;
    margin-bottom: auto;
}

.footer-tab-bar > a.btn,
.footer-tab-bar  .dropdown-nav > a.btn {
    color: white;
    font-size: 1rem;
}

.footer-tab-bar > a.btn .btn-content > i:first-of-type,
.footer-tab-bar > .dropdown-nav > a.btn .btn-content > i:first-of-type {
    margin-bottom: .25rem;
    font-size: 1.25rem;
}

.footer-tab-bar > .dropdown-nav .dropdown-wrapper .dropdown {
    bottom: 3rem;
    right: 0rem;
}

.meeting-detail-header-buttons > .dropdown-nav {
    margin-top: auto;
    margin-bottom: auto;
    margin-left: .5rem;
    margin-right: .5rem;
    display: flex;
}

.meeting-detail-header-buttons > .dropdown-nav .dropdown-wrapper .dropdown {
    top: 2.5rem;
    right: 0rem;
}

.meeting-detail-header-buttons > a.btn,
.meeting-detail-header-buttons .dropdown-nav > a.btn {
    font-size: .75rem;
    margin-right: .5rem;
    margin-top: auto;
    margin-bottom: auto;
}


.meeting-detail-header-buttons .dropdown-nav > a.btn {
    color: white;
}


.meeting-detail-header-buttons a.btn .btn-content > i:first-of-type,
.meeting-detail-header-buttons .dropdown-nav > a.btn .btn-content > i:first-of-type {
    margin-bottom: .25rem;
    font-size: 1rem;
}

.note-disclaimer {
    bottom: 5rem;
}

.flex .h-spaced + .h-spaced {
    margin-left: .5rem;
}

.flex .h-spaced:last-0f-type {
    margin-left: 0;
}

@media (min-width: 768px) {
    .readonly-meeting-detail .modal-content .content {
        height: calc(100% - 9rem);
    }

    .editable-meeting-detail .modal-content .content {
        height: calc(100% - 9rem);
    }

    .modal-footer .h-5 {
        height: calc(5rem - 1px);
    }
}

@media (max-width: 767px) {
    .meeting-detail-header-buttons > .dropdown-nav .dropdown-wrapper .dropdown.open {
        display: none !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/components.css"],"names":[],"mappings":"AAAA,SAAS;;AAET;IACI,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,sBAAsB;IACtB,2BAA2B;IAC3B,yCAAyC;IACzC,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,OAAO;AACX;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA,oBAAoB;;AAEpB;IACI,cAAc;IACd,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA,YAAY;AACZ;;;;;;;;;;;;IAYI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI;;;KAGC;IACD,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;IAGI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA,YAAY;;AAEZ;IACI,oBAAoB;IACpB,cAAc;IACd,qBAAqB;IACrB,eAAe;AACnB;;AAEA;;IAEI,WAAW;IACX,eAAe;AACnB;;;AAGA,WAAW;;AAEX;IACI,aAAa;IACb,qBAAqB;IACrB,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;AAChB;;AAEA,UAAU;;AAEV;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;;IAEnB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,oBAAoB;AACxB;;;AAGA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;AACf;;AAEA;;IAEI,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,sBAAsB;IACtB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,OAAO;IACP,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,OAAO;IACP,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,OAAO;AACX;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;IACpB,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;;KAEC;IACD,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,qBAAqB;QACrB,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,6BAA6B;QAC7B,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,OAAO;QACP,gBAAgB;QAChB,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,SAAS;QACT,WAAW;IACf;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,yBAAyB;QACzB,qBAAqB;QACrB,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,6BAA6B;IACjC;AACJ;;;AAGA,UAAU;AACV;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA,WAAW;;AAEX,iCAAiC;AACjC;IACI,0BAA0B;AAC9B;;AAEA,2CAA2C;AAC3C;;EAEE,wBAAwB;EACxB,SAAS,EAAE,4BAA4B;AACzC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,iBAAiB;IACjB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,cAAc;IACd,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI;QACI,mBAAmB;QACnB,sBAAsB;IAC1B;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;;;AAIA;IACI,aAAa;AACjB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI;;QAEI,cAAc;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,8BAA8B;IAC9B,qBAAqB;IACrB,aAAa;AACjB;;;AAGA,WAAW;;AAEX;IACI,kCAAkC;IAClC,oBAAoB;IACpB,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI;;KAEC;IACD,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;;;AAKA,iBAAiB;AACjB;IACI,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;AACzB;;;AAGA;IACI,0BAA0B;IAC1B,6FAA6F;IAC7F,4BAA4B;IAC5B,6BAA6B;IAC7B,+BAA+B;IAC/B,2BAA2B;;IAE3B,+BAA+B;IAC/B,mCAAmC;IACnC,mCAAmC;IACnC,iCAAiC;;IAEjC,uCAAuC;IACvC,2CAA2C;IAC3C,2CAA2C;IAC3C,yCAAyC;AAC7C;;AAEA;IACI,0BAA0B;IAC1B,gGAAgG;IAChG,4BAA4B;IAC5B,6BAA6B;IAC7B,+BAA+B;IAC/B,2BAA2B;;IAE3B,+BAA+B;IAC/B,mCAAmC;IACnC,mCAAmC;IACnC,iCAAiC;;IAEjC,uCAAuC;IACvC,2CAA2C;IAC3C,2CAA2C;IAC3C,yCAAyC;AAC7C;;AAEA;IACI,0CAA0C;IAC1C,0CAA0C;AAC9C;;AAEA;IACI;QACI,6BAA6B;MAC/B;;MAEA;QACE,4BAA4B;MAC9B;AACN;;CAEC;GACE;KACE,6BAA6B;GAC/B;;GAEA;KACE,4BAA4B;GAC9B;CACF;;;CAGA,cAAc;CACd;IACG,WAAW;IACX,YAAY;IACZ,mBAAmB;CACtB;;CAEA;KACI,UAAU;KACV,yBAAyB;CAC7B;;CAEA;KACI,aAAa;KACb,gBAAgB;KAChB,yBAAyB;KACzB,kBAAkB;CACtB;;CAEA;IACG,kBAAkB;IAClB,MAAM;IACN,WAAW;CACd;;CAEA;KACI,kBAAkB;KAClB,WAAW;KACX,YAAY;KACZ,UAAU;CACd;;CAEA;;IAEG,qBAAqB;IACrB,cAAc;CACjB;;CAEA;IACG,sBAAsB;IACtB,6BAA6B;CAChC;;CAEA;IACG,WAAW;IACX,6BAA6B;CAChC;;CAEA;KACI,gCAAgC;CACpC;;CAEA;;KAEI,WAAW;KACX,6BAA6B;CACjC;;CAEA;IACG,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,gDAAgD;IAChD,wCAAwC;IACxC,SAAS;IACT,UAAU;IACV,6BAA6B;IAC7B,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,0BAA0B;AAC9B;;;AAGA,UAAU;AACV;IACI,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,uBAAuB;IACvB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,MAAM;IACN,QAAQ;IACR,OAAO;IACP,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,cAAc;AAClB;;;AAGA;IACI,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;IACjB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,UAAU;IACV,iBAAiB;IACjB,UAAU;AACd;;AAEA;;;;CAIC;AACD;IACI,gBAAgB;AACpB;;;AAGA,iBAAiB;AACjB;IACI,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,QAAQ;IACR,OAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;IAC7B,mCAAmC;IACnC,kCAAkC;IAClC,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;;AAGA,mBAAmB;AACnB;IACI,aAAa;IACb,sBAAsB;IACtB;AACJ;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;IACb,cAAc;AAClB;;;AAGA;IACI,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,+BAA+B;IAC/B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;;AAGA,wBAAwB;AACxB;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB;4FACwF;AAC5F;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB;2FACuF;AAC3F;;AAEA;IACI,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;;;;;IAMI,SAAS;AACb;;AAEA;;;;;;IAMI,iBAAiB;IACjB,aAAa;AACjB;;;AAGA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,OAAO;AACX;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI;;QAEI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;;;;;;;;;;;;QAYI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;;;;;;;;;;;;QAYI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;;;;;;;;;;;;QAYI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;;;;;;;;;;;;QAYI,wBAAwB;IAC5B;AACJ;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;;AAGA;IACI,uBAAuB;IACvB,gDAAgD;IAChD,wCAAwC;IACxC,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gCAAgC;IAChC,4BAA4B;IAC5B,wBAAwB;IACxB,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;IACX,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;EACA;QACM,kBAAkB;QAClB,WAAW;IACf;AACJ;AACA;IACI;QACI,eAAe;QACf,WAAW;IACf;IACA;QACI,kBAAkB;QAClB,WAAW;IACf;AACJ;;;AAGA;IACI,YAAY;IACZ,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;;IAEI,0BAA0B;IAC1B,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,iBAAiB;IACjB,YAAY;IACZ,6BAA6B;IAC7B,aAAa;AACjB;;AAEA;;IAEI,YAAY;AAChB;AACA;;IAEI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yDAAyD;IACzD,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,MAAM;IACN,SAAS;AACb;;;AAGA;IACI,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,OAAO;IACP,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;CACnB;;AAED;IACI,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,uBAAuB;IACvB,mBAAmB;IACnB,OAAO;IACP,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;AAEA;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;AAClB;;AAEA,UAAU;AACV;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;;;AAIA,yBAAyB;AACzB;IACI,cAAc;IACd,0BAA0B;IAC1B,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,6DAA6D;IAC7D,yBAAyB;IACzB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,YAAY;IACZ,6BAA6B;IAC7B,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;;IAEI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA;IACI,YAAY;AAChB;;;AAGA;;IAEI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ","sourcesContent":["/* card */\r\n\r\n.card {\r\n    border: 1px solid #EEEEEE;\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-width: 0;\r\n    background-color: #fff;\r\n    background-clip: border-box;\r\n    box-shadow: 0 2px 1px rgba(0, 0, 0, 0.05);\r\n    border-radius: 0.27rem;\r\n}\r\n\r\n.card + .card {\r\n    margin-top: 1rem;\r\n}\r\n\r\n.card.raised {\r\n    box-shadow: 0 10px 18px 0 rgba(62, 57, 107, 0.2);\r\n}\r\n\r\n.card .card-header {\r\n    padding: 1rem;\r\n}\r\n\r\n.card .card-header h1, .card .card-header h2, .card .card-header h3, .card .card-header h4, .card .card-header h5, .card .card-header h6 {\r\n    margin: auto;\r\n    flex: 1;\r\n}\r\n\r\n.card .card-header .button-container {\r\n    margin: auto;\r\n}\r\n\r\n.card .card-header .btn:not(.btn-lg) {\r\n    padding: .25rem 1rem;\r\n    font-size: .75rem;\r\n}\r\n\r\n.card .card-header img {\r\n    margin: auto;\r\n}\r\n\r\n.card .card-header .labeled-divider {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.card .card-main {\r\n    padding: 1rem;\r\n}\r\n\r\n.card .card-footer {\r\n    padding: 1rem;\r\n}\r\n\r\n/* labeled divider */\r\n\r\n.labeled-divider {\r\n    margin: 2rem 0;\r\n    line-height: 0.1rem;\r\n    border-bottom: 1px solid #dadada;\r\n    text-align: center;\r\n    font-size: .8rem;\r\n    color: #6F7274;\r\n}\r\n\r\n.labeled-divider span {\r\n    background-color: #fff;\r\n    padding: .75rem;\r\n}\r\n\r\n.dinning-table {\r\n    user-select: none;\r\n}\r\n\r\n.dinning-table:hover .resize-handle {\r\n    display: block;\r\n}\r\n\r\n.resize-handle {\r\n    display: none;\r\n}\r\n\r\n/* buttons */\r\nh1 .btn,\r\nh2 .btn,\r\nh3 .btn,\r\nh4 .btn,\r\nh5 .btn,\r\nh6 .btn,\r\n.card .card-header h1 .btn,\r\n.card .card-header h2 .btn,\r\n.card .card-header h3 .btn,\r\n.card .card-header h4 .btn,\r\n.card .card-header h5 .btn,\r\n.card .card-header h6 .btn {\r\n    padding: 0;\r\n    font-size: 1.25rem;\r\n}\r\n\r\n.btn {\r\n    border: 1px solid transparent;\r\n    padding: 0.75rem 1rem;\r\n    font-size: 1rem;\r\n    line-height: 1.25;\r\n    border-radius: 0.21rem;\r\n    white-space: nowrap;\r\n}\r\n\r\n.btn:focus {\r\n    outline: none;\r\n}\r\n\r\n.btn-lg {\r\n    padding: 1rem 1.25rem;\r\n    font-size: 1.1rem;\r\n    line-height: 1.25;\r\n    border-radius: 0.27rem;\r\n}\r\n\r\n.btn-sm {\r\n    padding: .25rem .3rem;\r\n    font-size: .75rem;\r\n    border-radius: 0.15rem;\r\n    min-height: 2rem;\r\n}\r\n\r\n.btn-xl {\r\n    padding: 1rem 1.25rem;\r\n    font-size: 2rem;\r\n    line-height: 1.25;\r\n    border-radius: 0.27rem;\r\n}\r\n\r\n.btn:not(:disabled):not(.disabled):not([disabled]) {\r\n    cursor: pointer;\r\n}\r\n\r\n.btn:disabled,\r\n.btn.disabled,\r\n.btn[disabled] {\r\n    cursor: not-allowed;\r\n}\r\n\r\n.btn-full-width {\r\n    display: block;\r\n    width: 100%;\r\n}\r\n\r\n.btn-primary {\r\n    /*\r\n        border-color: #03A9F4;\r\n        background-color: #03A9F4;\r\n    */\r\n    border-color: #005377;\r\n    background-color: #005377;\r\n    color: #FFFFFF;\r\n}\r\n\r\n.btn-secondary {\r\n    border-color: #3A4856;\r\n    background-color: #3A4856;\r\n    color: #fff;\r\n}\r\n\r\n.btn-white {\r\n    color: #fff;\r\n}\r\n\r\n.btn-danger {\r\n    border-color: #DA4453;\r\n    background-color: #DA4453;\r\n    color: #FFFFFF;\r\n}\r\n\r\n.btn.btn-icon {\r\n    line-height: 1;\r\n    border: none;\r\n    background: transparent;\r\n    padding: 0;\r\n}\r\n\r\n.btn.btn-icon.btn-secondary {\r\n    color: #3A4856;\r\n}\r\n\r\n.btn.btn-icon.btn-primary {\r\n    color: #3A4856;\r\n}\r\n\r\n.btn.btn-icon.btn-danger {\r\n    color: #DA4453;\r\n}\r\n\r\n.btna.btn-icon.btn-secondary * {\r\n    vertical-align: middle;\r\n}\r\n\r\n.btn .btn-content {\r\n    display: inline-flex;\r\n    margin: auto;\r\n}\r\n\r\n.btn:not(.btn-icon) .btn-content > i:first-of-type {\r\n    margin-left: .5rem;\r\n}\r\n\r\n.btn:not(.btn-icon) .btn-content > span {\r\n    padding-left: .5rem;\r\n    padding-right: .5rem;\r\n}\r\n\r\n.btn.btn-icon:not(.btn-no-inner-margin) .btn-content > span + i {\r\n    margin-left: .5rem;\r\n}\r\n\r\n.btn.btn-icon:not(.btn-no-inner-margin) .btn-content > i + span {\r\n    margin-left: .5rem;\r\n}\r\n\r\n.btn-group .btn:not(:last-of-type) {\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n}\r\n\r\n.btn-group .btn + .btn {\r\n    margin-left: -1px;\r\n    border-top-left-radius: 0;\r\n    border-bottom-left-radius: 0;\r\n    border-left: 1px solid #ccc;\r\n}\r\n\r\n.btn-group .btn {\r\n    opacity: .5;\r\n}\r\n\r\n.btn-group .btn.active, .btn-group .btn:not(.disabled):hover {\r\n    opacity: 1;\r\n}\r\n\r\n.btn-group .btn-primary + .btn-primary {\r\n    border-left-color: #ededed;\r\n}\r\n\r\n.btn-group .btn-sm {\r\n    padding: .25rem 1rem;\r\n}\r\n\r\n.btn-icon-stacked {\r\n    text-align: center;\r\n}\r\n\r\n.btn.btn-icon.btn-icon-stacked .btn-content i:first-of-type,\r\n.btn.btn-icon.btn-icon-stacked .btn-content i:last-of-type,\r\n.btn.btn-icon.btn-icon-stacked .btn-content i + span {\r\n    margin-left: 0;\r\n    margin-right: 0;\r\n}\r\n\r\n.btn-icon-stacked + btn-icon-stacked {\r\n    margin-left: .5rem;\r\n}\r\n\r\n.btn-icon-stacked .btn-content {\r\n    display: block;\r\n}\r\n\r\n.btn-icon-stacked .btn-content span {\r\n    display: block;\r\n}\r\n\r\n.btn.btn-link {\r\n    padding: 0;\r\n    border: none;\r\n    background-color: transparent;\r\n}\r\n\r\n.btn.btn-link .btn-content i + span {\r\n    margin-left: .5rem;\r\n}\r\n\r\n.btn.btn-link .btn-content > span {\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n}\r\n\r\n.floating-label .btn-show-password {\r\n    position: absolute;\r\n    top: 1rem;\r\n    right: 1rem;\r\n}\r\n\r\n.stacked-label .btn-show-password {\r\n    position: absolute;\r\n    right: 1.75rem;\r\n    top: 1.75rem;\r\n}\r\n\r\n.loading-placeholder.button {\r\n    height : 2.875rem;\r\n    display: inline-block;\r\n    width  : 8rem;\r\n    margin : 0.375rem;\r\n}\r\n\r\n.modal-footer .btn .ti-trash {\r\n    font-size: 1.5rem;\r\n}\r\n\r\n\r\n.terms-and-conditions-container {\r\n    margin-top: 1rem;\r\n    padding: .5rem;\r\n    border: 1px solid #ededed;\r\n    height: 10rem;\r\n    overflow-y: auto;\r\n    background-color: #fff;\r\n    font-size: .75rem;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.email-report-message-textarea textarea {\r\n    height: 250px;\r\n}\r\n\r\n/* anchors */\r\n\r\na {\r\n    /* color: #3BAFDA; */\r\n    color: #005377;\r\n    text-decoration: none;\r\n    cursor: pointer;\r\n}\r\n\r\na.disabled, a[disabled],\r\nbutton.disabled, button[disabled] {\r\n    opacity: .5;\r\n    cursor: default;\r\n}\r\n\r\n\r\n/* Alerts */\r\n\r\n.alert {\r\n    padding: 1rem;\r\n    margin-bottom: 1.5rem;\r\n    border: 1px solid transparent;\r\n    border-radius: .25rem;\r\n    text-align: center;\r\n}\r\n\r\n.alert.alert-danger {\r\n    color: #a94442;\r\n    background-color: #f2dede;\r\n    border-color: #ebccd1;\r\n}\r\n\r\n.alert.alert-success {\r\n    border: 1px solid #566787;\r\n    background-color: #8495b7;\r\n    color: white;\r\n}\r\n\r\n/* table */\r\n\r\ntable.table {\r\n    border-spacing: 0px;\r\n}\r\n\r\ntable thead tr th a {\r\n    width: 100%;\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    color: #55595c;\r\n}\r\n\r\ntable thead tr th a i {\r\n    margin-left: 0.625rem;\r\n}\r\n\r\n.table-header .records-per-page-wrapper span {\r\n    margin: auto;\r\n}\r\n\r\n.table-header .records-per-page-wrapper select {\r\n    margin: auto .5rem auto 0;\r\n    width: 4rem;\r\n}\r\n\r\n.table-header input, .table-header select {\r\n    height: 2.125rem;\r\n    border-radius: 0.1875rem;\r\n    border-color: #ddd;\r\n    box-shadow: none;\r\n}\r\n\r\n.table-header select.input-field:not([size]):not([multiple]) {\r\n    height: 2.125rem;\r\n}\r\n\r\n.table-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding: 0;\r\n    font-size: .85rem;\r\n}\r\n\r\n.table-header .btn {\r\n    height: 2.125rem;\r\n}\r\n\r\n.table-header label {\r\n    font-weight: normal;\r\n    margin-left: 0.625rem;\r\n}\r\n\r\n.table-header select, .table-header input {\r\n    display: inline-block;\r\n    margin:0;\r\n}\r\n\r\n.table-header input {\r\n    width: 12.5rem;\r\n    display: inline-block;\r\n}\r\n\r\ntable.table td div {\r\n    display: inline-block;\r\n}\r\n\r\ntable.table tr td.table-row-sub-head {\r\n    border-bottom: 1px solid #CDCDCD;\r\n    padding-bottom: 3px;\r\n    padding-top: 1rem;\r\n    color: #777;\r\n}\r\n\r\ntable .fit-content {\r\n    width:1%;\r\n    white-space:nowrap;\r\n}\r\n\r\ntable tr.selected td {\r\n    background-color: #CDCDCD;\r\n}\r\n\r\n.filter-group {\r\n    display: flex;\r\n    margin: auto 0;\r\n    white-space: nowrap;\r\n\r\n    width: 100%;\r\n    flex-direction: column;\r\n}\r\n\r\n.filter-group label {\r\n    margin: auto 0;\r\n}\r\n\r\n.filter-group .form-control {\r\n    flex: 1;\r\n}\r\n\r\n.filter-group select.form-control {\r\n    width: 6.875rem;\r\n}\r\n\r\n.filter-icon {\r\n    float: right;\r\n    margin-top: 0.4375rem;\r\n}\r\n\r\n.filter-icon i {\r\n    font-size: 1.125rem;\r\n    opacity: 0.7;\r\n}\r\n\r\ntable.table {\r\n    border-right-width: 0;\r\n    border-top-width: 0;\r\n    width: 100%;\r\n    border-left: 1px solid #C2CCD6;\r\n    border-bottom: 1px solid #C2CCD6;\r\n}\r\n\r\ntable.table.no-border {\r\n    border:none;\r\n}\r\n\r\ntable.table tr td {\r\n    border-top: 1px solid #C2CCD6;\r\n    border-bottom-width: 0;\r\n    border-left-width: 0;\r\n}\r\n\r\n\r\ntable.table.no-border tr td {\r\n    border: none;\r\n}\r\n\r\ntable.table tr.deleting td {\r\n    text-decoration: line-through;\r\n    color: #ccc;\r\n}\r\n\r\ntable.table tr.deleting td a,\r\ntable.table tr.deleting td button {\r\n    text-decoration: line-through;\r\n    color: #ccc;\r\n}\r\n\r\ntable.table thead th {\r\n    text-transform: uppercase;\r\n    background-color: #fff;\r\n    border-top: 1px solid #C2CCD6;\r\n    border-bottom: 1px solid #C2CCD6;\r\n}\r\n\r\ntable.table thead th a {\r\n    padding: 0;\r\n}\r\n\r\ntable.table thead th .btn {\r\n    font-size: 0.85rem;\r\n}\r\n\r\ntable.table.no-border thead th {\r\n    border-top: none;\r\n    border-right: none;\r\n}\r\n\r\ntable.table tr th, table.table tr td {\r\n    padding: .5rem 0.9375rem;\r\n    vertical-align: middle;\r\n    font-size: .9rem;\r\n    border-right: 1px solid #C2CCD6;\r\n}\r\n\r\n.table-hover tbody tr.loading:hover {\r\n    background-color: transparent;\r\n}\r\n\r\ntable.table-striped tbody:nth-of-type(even) {\r\n    background-color: #F3F5F7;\r\n}\r\n\r\ntable.table-striped tbody tr.loading:nth-of-type(even):hover {\r\n    background-color: #f5f5f5;\r\n}\r\n\r\ntable.table-striped.table-hover tbody:hover {\r\n    background: #f5f5f5;\r\n}\r\n\r\ntable tr.deleting td {\r\n    color: #ccc;\r\n    text-decoration: line-through;\r\n}\r\n\r\ntable tr td .loading-placeholder {\r\n    width: 100%;\r\n    margin: 0.3rem 0 0.3rem 0;\r\n}\r\n\r\ntable.table.table-small tr th,\r\ntable.table.table-small tr td {\r\n    padding: .25rem .9375rem;\r\n}\r\n\r\ntable .expanded-content {\r\n    display: none;\r\n}\r\n\r\ntable .expanded-content.active {\r\n    display: table-row;\r\n}\r\n\r\ntable .expand-cell {\r\n    cursor: pointer;\r\n}\r\n\r\n.record-not-found-state, .empty-state {\r\n    text-align: center;\r\n    padding: 1.25rem;\r\n}\r\n\r\n.record-not-found-state i, .empty-state i {\r\n    font-size: 5rem;\r\n    display: inline-block;\r\n    margin-bottom: 1.25rem;\r\n}\r\n\r\n.record-not-found-state b, .empty-state b {\r\n    display: inline-block;\r\n    font-size: 1.25rem;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.table-pager-row + table.table {\r\n    margin-top: 1rem;\r\n}\r\n\r\n.table-pager-row {\r\n    margin-top: .5rem;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    flex-direction: column-reverse;\r\n}\r\n\r\n.table-header + .tag-wrapper {\r\n    margin-top: .5rem;\r\n}\r\n\r\ntable .button-column-spacer {\r\n    width: 4rem;\r\n}\r\n\r\ntable.modal-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n}\r\n\r\ntable.modal-table th {\r\n    font-weight: bold;\r\n    padding: .5rem;\r\n    border-bottom: 2px solid #333;\r\n}\r\n\r\ntable.modal-table td {\r\n    padding: .5rem;\r\n}\r\n\r\n.record-count {\r\n    margin: auto 0;\r\n    margin-top: 1rem;\r\n    text-align: center;\r\n    font-size: 0.85rem;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.record-count .loading-placeholder {\r\n    width: 6rem;\r\n}\r\n\r\n.pagination {\r\n    flex: 1;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding-left: 0;\r\n    list-style: none;\r\n    border-radius: 0.25rem;\r\n}\r\n\r\n.pagination .btn {\r\n    flex: 1;\r\n    margin: auto .25rem auto 0;\r\n    padding: .5rem 0;\r\n}\r\n\r\n.pagination .btn:not(:first-of-type) {\r\n    margin-left: .25rem;\r\n}\r\n\r\n.pagination .btn:last-of-type {\r\n    margin-right: 0;\r\n}\r\n\r\n.page-item.disabled .page-link {\r\n    opacity: .25;\r\n    cursor: default;\r\n}\r\n\r\n.pagination {\r\n    margin: auto 0;\r\n    flex: 0;\r\n}\r\n\r\n.pagination .loading-placeholder {\r\n    width: 3rem;\r\n    margin-left: 1rem;\r\n    min-height: 1rem;\r\n    margin-top: 0.4375rem;\r\n    margin-bottom: 0.4375rem;\r\n}\r\n\r\n.pagination li a {\r\n    border: none;\r\n    font-size: 0.8125rem;\r\n    min-width: 1.875rem;\r\n    min-height: 1.875rem;\r\n    border-radius: 0.125rem !important;\r\n    text-align: center;\r\n    padding: 0 0.375rem;\r\n    display: block;\r\n    color: #999;\r\n}\r\n\r\n.pagination .page-item:not(:disabled):not(.disabled):hover {\r\n    background-color: #e9ecef;\r\n}\r\n\r\n.pagination li a:hover {\r\n    color: #666;\r\n}\r\n\r\n.pagination li.active a {\r\n    /*\r\n    background: #03A9F4;\r\n    */\r\n    background:#005377;\r\n    color: #fff;\r\n}\r\n\r\n.pagination li.active a.page-link:hover {\r\n    background: #0397d6;\r\n}\r\n\r\n.pagination li.disabled i {\r\n    color: #ccc;\r\n}\r\n\r\n.pagination li i {\r\n    font-size: 1rem;\r\n    padding-top: 0.375rem\r\n}\r\n\r\n.pagination .page-link:focus {\r\n    box-shadow: none;\r\n}\r\n\r\n.pagination .page-link i {\r\n    display: none;\r\n}\r\n\r\n@media (min-width: 575px) {\r\n    .form-container .checkbox.inline-checkbox {\r\n        margin-top: 2.5625rem;\r\n        margin-bottom: .75rem;\r\n    }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .table-header .records-per-page-wrapper {\r\n        display: flex;\r\n    }\r\n    .table-header .records-per-page-wrapper select {\r\n        margin: auto .5rem auto .5rem;\r\n        width: unset;\r\n    }\r\n\r\n    .table-header .filter-group input, .table-header .filter-group select {\r\n        margin-left: 0.3125rem;\r\n    }\r\n\r\n    .filter-group {\r\n        flex: 1;\r\n        max-width: 24rem;\r\n        width: 100%;\r\n        flex-direction: row;\r\n    }\r\n    .table-pager-row {\r\n        flex-direction: row;\r\n    }\r\n    .record-count {\r\n        margin-top: auto;\r\n        margin-bottom: auto;\r\n    }\r\n\r\n    .modal-container.small .modal-content {\r\n        width:50%;\r\n        height: 60%;\r\n    }\r\n\r\n    .modal-container .modal-content {\r\n        width: 75%;\r\n        max-width: 60rem;\r\n        margin: auto;\r\n        height: 85%;\r\n    }\r\n\r\n    .modal-content .content {\r\n        height: calc(100% - 4rem);\r\n        overflow: hidden auto;\r\n        background: #f3f3f3;\r\n    }\r\n\r\n    .modal-content .content.has-footer {\r\n        height: calc(100% - 9rem);\r\n    }\r\n\r\n    .modal-content .modal-footer {\r\n        border-top: 1px solid #e0e0e0;\r\n    }\r\n}\r\n\r\n\r\n/* Forms */\r\n.form-container h4 {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.form-container .input-field {\r\n    margin-top: 1rem;\r\n    font-size: .9rem;\r\n    position: relative;\r\n}\r\n\r\n.form-container .input-field:last-of-type {\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.form-container+.form-container {\r\n    margin-top: 1rem;\r\n}\r\n\r\n.form-footer {\r\n    display: flex;\r\n    padding-top: 1rem;\r\n    padding-bottom: 1rem;\r\n}\r\n\r\n.form-footer > * {\r\n    margin: auto;\r\n}\r\n\r\n.form-footer .btn-container {\r\n    flex: 1;\r\n    text-align: right;\r\n}\r\n\r\n.btn + .btn {\r\n    margin-left: .5rem;\r\n}\r\n\r\n.has-badge {\r\n    position: relative;\r\n}\r\n\r\n.has-badge .button-badge {\r\n    background: #DA4453;\r\n    color: #333;\r\n    font-weight: bold;\r\n    padding: 3px;\r\n    border-radius: 15px;\r\n    display: inline-block;\r\n    width: auto;\r\n    min-width: 15px;\r\n    font-size: 10px;\r\n    position: absolute;\r\n    top: -5px;\r\n    right: -5px;\r\n}\r\n\r\n/* inputs */\r\n\r\n/* Remove controls from Firefox */\r\ninput[type=number] {\r\n    -moz-appearance: textfield;\r\n}\r\n\r\n/* Remove controls from Safari and Chrome */\r\ninput[type=number]::-webkit-inner-spin-button,\r\ninput[type=number]::-webkit-outer-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0; /* Removes leftover margin */\r\n}\r\n\r\n.input-field.digit-field input {\r\n    padding: 0.5rem;\r\n    width: 3rem;\r\n    text-align: center;\r\n}\r\n\r\n.input-field.field-fit-content input,\r\n.input-field.field-fit-content select {\r\n    width: fit-content;\r\n}\r\n\r\n.input-field.text-right input {\r\n    text-align: right;\r\n}\r\n\r\n.input-field.floating-label {\r\n    position: relative;\r\n}\r\n\r\n.input-field.floating-label label {\r\n    position: absolute;\r\n    background-color: white;\r\n    padding: 0 .25rem;\r\n}\r\n.input-field.floating-label label span.invalid {\r\n    margin-left: 1rem;\r\n}\r\n\r\n.input-field.floating-label.input-lg .icon-wrapper {\r\n    left: 0rem;\r\n    position: absolute;\r\n    top: 0rem;\r\n    padding-top: 1rem;\r\n    width: 3.5rem;\r\n    display: flex;\r\n}\r\n\r\n.input-field.floating-label.input-lg .icon-wrapper i {\r\n    margin: auto;\r\n}\r\n\r\n.input-field.floating-label label.active {\r\n    font-size: .75rem;\r\n}\r\n\r\n.input-field.floating-label.input-lg label.active {\r\n    top: -0.6rem;\r\n}\r\n\r\n.input-field.floating-label.input-lg label {\r\n    top: .75rem;\r\n    left: 1rem;\r\n}\r\n\r\n.input-field.floating-label.icon-field.input-lg label {\r\n    left: 3.5rem;\r\n}\r\n\r\n.input-field.floating-label.icon-field.input-lg label.active {\r\n    left: .5rem;\r\n}\r\n\r\n.input-field:not(.radio) input, .input-field select, .input-field textarea {\r\n    border: 1px solid #d4d4d4;\r\n    width: 100%;\r\n    padding-left: .5rem;\r\n    padding-right: .5rem;\r\n    border-radius: 0.22rem;\r\n    padding: .5rem;\r\n    background-color: #fff;\r\n    font-size: 1rem;\r\n}\r\n\r\n@media (max-width: 575px) {\r\n    .input-field:not(.radio) input, .input-field select, .input-field textarea {\r\n        padding-top: .25rem;\r\n        padding-bottom: .25rem;\r\n    }\r\n}\r\n\r\n.input-field:not(.radio) input, .input-field select {\r\n    height: 2.05rem;\r\n}\r\n\r\n.input-field.input-lg input {\r\n    height: 3rem;\r\n    padding: 0.75rem;\r\n    font-size: 1.1rem;\r\n    line-height: 1.45;\r\n    border-radius: 0.27rem;\r\n}\r\n\r\n.input-field.input-sm input, .input-field.input-sm select {\r\n    padding: .2rem;\r\n    height: 1.75rem;\r\n}\r\n\r\n.input-field.input-xs input, .input-field.input-xs select {\r\n    padding: .1rem;\r\n    height: 1.5rem;\r\n}\r\n\r\n.input-field.input-xs-long input, .input-field.input-xs-long select {\r\n    padding: .1rem;\r\n    height: 1.5rem;\r\n    width: 15rem;\r\n}\r\n\r\n.input-field.icon-field input {\r\n    padding-right: 1.25rem;\r\n    padding-left: calc(3.375rem + 2px);\r\n}\r\n\r\n.input-field input:focus, .input-field textarea:focus {\r\n    color: #4E5154;\r\n    border-color: #3BAFDA;\r\n    outline: 0;\r\n}\r\n\r\n.input-field input.invalid, .input-field select.invalid, .input-field textarea.invalid {\r\n    border-color: red;\r\n}\r\n\r\n.input-field input + span.invalid, .input-field select + span.invalid, .input-field textarea + span.invalid{\r\n    height: 0;\r\n    display: block;\r\n}\r\n\r\n.invalid {\r\n    color: red;\r\n}\r\n\r\n\r\n\r\n.inline-label.input-field, .inline-label .input-field {\r\n    display: flex;\r\n}\r\n\r\n.inline-label.input-field input:not(.radio), .inline-label .input-field input:not(.radio) {\r\n    flex: 1;\r\n}\r\n\r\n.inline-label label, .inline-label .input-field label {\r\n    margin: auto .25rem auto 0;\r\n}\r\n\r\n.inline-label label span.invalid,\r\n.inline-label .input-field label span.invalid {\r\n    right: .15rem;\r\n    position: absolute;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n    .grid-container .input-field[class^='sm-'].inline-label label span.invalid,\r\n    .grid-container .input-field[class*=' sm-'].inline-label label span.invalid {\r\n        right: 1.15rem;\r\n    }\r\n}\r\n\r\n.placeholder-label {\r\n    position: absolute;\r\n    font-size: 75%;\r\n}\r\n\r\n.bold-label label {\r\n    font-weight: bold;\r\n}\r\n\r\n.input-field.no-label label {\r\n    display: none;\r\n}\r\n\r\n.stacked-label.input-field {\r\n    display: flex;\r\n    flex-direction: column;\r\n    text-align: left;\r\n}\r\n\r\n.stacked-label.input-field span.invalid {\r\n    text-align: right;\r\n}\r\n\r\n.form-container .section-header {\r\n    border-bottom: 1px solid #55595c;\r\n    margin-top: 2rem;\r\n}\r\n\r\n.form-container .checkbox {\r\n    margin-top: 1rem;\r\n}\r\n\r\n.checkbox label {\r\n    display: flex;\r\n    font-size: .9rem;\r\n    width: fit-content;\r\n}\r\n\r\n.checkbox:not(.label-right) label input {\r\n    margin: auto auto auto .5rem;\r\n}\r\n\r\n.checkbox.label-right label input {\r\n    margin: auto .5rem auto auto;\r\n}\r\n\r\n.checkbox.no-label label span.label {\r\n    display: none;\r\n}\r\n\r\n.checkbox.no-label label input {\r\n    margin-left: auto;\r\n}\r\n\r\n.checkbox .label.right-label {\r\n    display: none;\r\n}\r\n\r\n.checkbox.label-right .label.left-label {\r\n    display: none;\r\n}\r\n\r\n.checkbox.label-right .label.right-label {\r\n    display: inline;\r\n}\r\n\r\n@media (min-width: 575px) {\r\n    .checkbox.sm-4:nth-of-type(2) label {\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n    }\r\n\r\n    .checkbox.sm-4:nth-of-type(3) label {\r\n        margin-left: auto;\r\n    }\r\n}\r\n\r\n.toggle-switch-wrapper {\r\n    position: relative;\r\n    display: inline-block;\r\n    width: 40px;\r\n    height: 21px;\r\n    margin-left: .5rem;\r\n}\r\n\r\n.toggle-switch-wrapper input.toggle-switch {\r\n    opacity: 0;\r\n    width: 0;\r\n    height: 0;\r\n}\r\n\r\n.toggle-switch-wrapper .toggle-switch-slider {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    transition: 0.3s;\r\n    cursor: pointer;\r\n    background: #AAA;\r\n    border-radius: 30px;\r\n}\r\n\r\n.toggle-switch-wrapper .toggle-switch-slider:before {\r\n    position: absolute;\r\n    content: \"\";\r\n    height: 17px;\r\n    width: 17px;\r\n    left: 3px;\r\n    bottom: 2.6px;\r\n    background-color: #fff;\r\n    border-radius: 50%;\r\n    transition: 0.3s;\r\n    top: 2px;\r\n}\r\n\r\n.toggle-switch-wrapper input:checked + .toggle-switch-slider {\r\n    background-color: #005377;\r\n}\r\n\r\n.toggle-switch-wrapper input:checked + .toggle-switch-slider:before {\r\n    transform: translateX(18px);\r\n}\r\n\r\n.toggle-switch-wrapper .toggle-switch-label {\r\n    position: absolute;\r\n    left: 100%;\r\n    width: max-content;\r\n    line-height: 30px;\r\n    cursor: pointer;\r\n}\r\n\r\n.input-field .loading-placeholder {\r\n    display      : block;\r\n    border-radius: 0.25rem;\r\n    height       : 0.6rem;\r\n}\r\n\r\n.input-field label.loading-placeholder {\r\n    width: 6.25rem;\r\n}\r\n\r\n.input-field .text-input.loading-placeholder {\r\n    height: 2rem;\r\n    margin: 0;\r\n    top   : 0.25rem;\r\n    width: 100%;\r\n}\r\n\r\n.search-field:not(.no-label) .input-field label,\r\n.input-field:not(.radio):not(.search-input-field):not(.no-label) label {\r\n    display: flex;\r\n    white-space: nowrap;\r\n}\r\n\r\n.search-field-wrapper {\r\n    position: relative;\r\n}\r\n\r\n.clear-search-button {\r\n    position: absolute;\r\n    right: .5rem;\r\n    opacity: 0.6;\r\n}\r\n\r\n.clear-search-button:hover {\r\n    opacity: 1;\r\n}\r\n\r\nhr {\r\n    border: .0625rem solid #005377;\r\n    border-radius: .25rem;\r\n    opacity: 0.25;\r\n}\r\n\r\n\r\n/* Badges */\r\n\r\n.badge {\r\n    padding: .1rem .25rem .1rem .25rem;\r\n    border-radius: 10rem;\r\n    color: #fff;\r\n    position: absolute;\r\n    right: -.25rem;\r\n    top: .25rem;\r\n    font-size: .75rem;\r\n}\r\n\r\n.badge-container {\r\n    position: relative;\r\n}\r\n\r\n\r\n.badge.badge-primary {\r\n    /*\r\n    background-color: #03A9F4;\r\n    */\r\n    background-color: #005377;\r\n}\r\n\r\n.badge.badge-secondary {\r\n    background-color: #3A4856;\r\n}\r\n\r\n.badge.badge-danger {\r\n    background-color: #DA4453;\r\n}\r\n\r\n\r\n\r\n\r\n/* placeholders */\r\n.loading-placeholder {\r\n    display      : block;\r\n    border-radius: 0.25rem;\r\n    height       : 0.6rem;\r\n}\r\n\r\n\r\n.card .shimmer, table .shimmer{\r\n    background       : #F5F5F6;\r\n    background-image : linear-gradient(to right, #F5F5F6 0%, #fff 20%, #F5F5F6 80%, #F5F5F6 100%);\r\n    background-repeat: no-repeat;\r\n    background-size  : 800px 100%;\r\n    display          : inline-block;\r\n    position         : relative;\r\n\r\n    animation-duration       : 1.5s;\r\n    animation-fill-mode      : forwards;\r\n    animation-iteration-count: infinite;\r\n    animation-timing-function: linear;\r\n\r\n    -webkit-animation-duration       : 1.5s;\r\n    -webkit-animation-fill-mode      : forwards;\r\n    -webkit-animation-iteration-count: infinite;\r\n    -webkit-animation-timing-function: linear;\r\n}\r\n\r\n.shimmer {\r\n    background       : #e0e0e0;\r\n    background-image : linear-gradient(to right, #e0e0e0 0%, #ededed 20%, #e0e0e0 80%, #e0e0e0 100%);\r\n    background-repeat: no-repeat;\r\n    background-size  : 800px 100%;\r\n    display          : inline-block;\r\n    position         : relative;\r\n\r\n    animation-duration       : 1.5s;\r\n    animation-fill-mode      : forwards;\r\n    animation-iteration-count: infinite;\r\n    animation-timing-function: linear;\r\n\r\n    -webkit-animation-duration       : 1.5s;\r\n    -webkit-animation-fill-mode      : forwards;\r\n    -webkit-animation-iteration-count: infinite;\r\n    -webkit-animation-timing-function: linear;\r\n}\r\n\r\n.shimmer:first-of-type {\r\n    animation-name        : placeholderShimmer;\r\n    -webkit-animation-name: placeholderShimmer;\r\n}\r\n\r\n@keyframes placeholderShimmer{\r\n    0% {\r\n        background-position: -800px 0;\r\n      }\r\n\r\n      100% {\r\n        background-position: 100vw 0;\r\n      }\r\n}\r\n\r\n @-webkit-keyframes placeholderShimmer {\r\n   0% {\r\n     background-position: -800px 0;\r\n   }\r\n\r\n   100% {\r\n     background-position: 100vw 0;\r\n   }\r\n }\r\n\r\n\r\n /* Data List */\r\n .data-list-wrapper .loading-placeholder {\r\n    width: 100%;\r\n    height: 3rem;\r\n    margin-bottom: 1rem;\r\n }\r\n\r\n ul.data-list {\r\n     padding: 0;\r\n     border: 1px solid #E0E0E0;\r\n }\r\n\r\n ul.data-list > li {\r\n     padding:.5rem;\r\n     list-style: none;\r\n     background-color: #EEEEEE;\r\n     position: relative;\r\n }\r\n\r\n ul.data-list > li a.btn-edit-data-item {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 2rem;\r\n }\r\n\r\n ul.data-list > li a.btn-remove-data-item {\r\n     position: absolute;\r\n     top: .25rem;\r\n     right: .5rem;\r\n     padding: 0;\r\n }\r\n\r\n ul.data-list > li.deleting a.btn-remove-data-item,\r\n ul.data-list > li.deleting a.btn-remove-data-item * {\r\n    text-decoration: none;\r\n    color: #005377;\r\n }\r\n\r\n .deleting *:not(.no-line-through){\r\n    color: #ccc !important;\r\n    text-decoration: line-through;\r\n }\r\n\r\n ul.data-list > li.deleting > *:not(.no-line-through) {\r\n    color: #ccc;\r\n    text-decoration: line-through;\r\n }\r\n\r\n .no-line-through, .no-line-through * {\r\n     text-decoration: none !important;\r\n }\r\n\r\n ul.data-list > li.deleting input,\r\n ul.data-list > li.deleting select {\r\n     color: #ccc;\r\n     text-decoration: line-through;\r\n }\r\n\r\n ul.data-list > li:nth-child(odd) {\r\n    background-color: #FFF;\r\n}\r\n\r\n.data-list > li a + a {\r\n    margin-left: .5rem;\r\n}\r\n\r\nul.data-list > li > .input-field:first-of-type {\r\n    margin-top:0;\r\n}\r\n\r\n.collapsable-button {\r\n    padding: 0;\r\n}\r\n\r\n.collapsable-button.active i {\r\n    transform: rotate(90deg);\r\n}\r\n\r\n.collapsable-button.btn:not(.btn-icon) .btn-content > i:first-of-type {\r\n    margin-left: 0;\r\n}\r\n\r\n.collapsable {\r\n    display: none;\r\n}\r\n\r\n.collapsable.active {\r\n    display: block;\r\n}\r\n\r\n.dropdown-wrapper {\r\n    position: relative;\r\n}\r\n\r\n.modal-content > header .dropdown-nav a:first-of-type i {\r\n    font-size: 1rem;\r\n}\r\n\r\n.dropdown-nav > .btn {\r\n    font-size: 1.25rem;\r\n}\r\n\r\n.dropdown-nav.white > .btn {\r\n    color: #fff;\r\n}\r\n\r\n.full-width .dropdown {\r\n    width: 100%;\r\n}\r\n\r\n.dropdown {\r\n    display: none;\r\n    list-style: none;\r\n    position: absolute;\r\n    background-color: #fff;\r\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, .08);\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, .08);\r\n    margin: 0;\r\n    padding: 0;\r\n    border-top: 1px solid #f6f6f6;\r\n    z-index: 1000;\r\n    font-size: 1rem;\r\n}\r\n\r\n.dropdown ul {\r\n    list-style: none;\r\n}\r\n\r\n.dropdown-nav.align-right .dropdown {\r\n    right: 0;\r\n}\r\n\r\n.dropdown.open {\r\n    display: block;\r\n}\r\n\r\n.dropdown li a {\r\n    display: block;\r\n    display: block;\r\n    min-width:10rem;\r\n    padding: .5rem 1rem;\r\n    color: #3A4856;\r\n    font-size: 1rem;\r\n}\r\n\r\n.dropdown li p {\r\n    padding: .5rem 1rem;\r\n}\r\n\r\n.page-nav li.seperator-top,\r\n.dropdown li.seperator-top {\r\n    border-top: 1px solid #ccc;\r\n}\r\n\r\n\r\n/* Modal */\r\n.modal-container .modal-content {\r\n    position: fixed;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    background-color: white;\r\n    z-index: 1003;\r\n    overflow-y: auto;\r\n}\r\n\r\n.modal-content > header {\r\n    background: #005377;\r\n    height: 4rem;\r\n    display: flex;\r\n    padding: 0 1.25rem;\r\n    color: white;\r\n}\r\n\r\n.modal-content > header a:first-of-type i {\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n    font-size: 2rem;\r\n}\r\n\r\n.modal-content > header > span {\r\n    flex: 1;\r\n    margin: auto;\r\n    font-size: 1.5rem;\r\n}\r\n\r\n.modal-content .content.has-footer {\r\n    min-height: calc(100% - 9rem);\r\n}\r\n\r\n.modal-content .modal-footer {\r\n    padding: 1rem;\r\n    display: flex;\r\n}\r\n\r\n.modal-content .modal-footer .btn-container {\r\n    margin-left: auto;\r\n}\r\n\r\n.modal-container .modal-background {\r\n    opacity: .7 !important;\r\n    background-color: black;\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    left: 0;\r\n    bottom: 0;\r\n    z-index: 1002;\r\n}\r\n\r\n.modal-container .confirmation-prompt {\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    padding-top: 0;\r\n}\r\n\r\n\r\n.modal-container .confirmation-prompt h4 {\r\n    background: #005377;\r\n    height: 4rem;\r\n    display: flex;\r\n    padding: 0 1.25rem;\r\n    color: white;\r\n    font-size: 1.5rem;\r\n    margin: 0 -1rem;\r\n    line-height: 4rem;\r\n}\r\n\r\n.tag-wrapper {\r\n    margin: -.25rem .5rem -.25rem 0;\r\n    font-size: .75rem;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.tag-heading {\r\n    white-space: nowrap;\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n}\r\n\r\n.tag {\r\n    margin: .25rem 0 .25rem .5rem;\r\n    background-color: #55595c;\r\n    color: white;\r\n    padding: .3rem .4rem;\r\n    border-radius: .3rem;\r\n    white-space: nowrap;\r\n    display: flex;\r\n}\r\n\r\n.btn-remove-tag {\r\n    margin-left: auto;\r\n    font-size: .75rem;\r\n    color: red;\r\n    font-weight: bold;\r\n    padding: 0;\r\n}\r\n\r\n/*\r\n.btn-remove-tag {\r\n    margin-left: .25rem; may not need at all\r\n}\r\n*/\r\n.tag .btn-remove-tag .btn-content > span {\r\n    padding-right: 0;\r\n}\r\n\r\n\r\n/* RIGHT SLIDER */\r\n.slider-background {\r\n    opacity: .7;\r\n    background-color: black;\r\n}\r\n\r\n.right-slider {\r\n    position: fixed;\r\n    right: -24rem;\r\n    top: 4rem;\r\n    background-color: #fff;\r\n    width: 20rem;\r\n    z-index: 1000;\r\n    bottom: 0;\r\n    transition: right 0.5s;\r\n    -webkit-transition: right 0.5s;\r\n}\r\n\r\n.right-slider .slider-content-wrapper {\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    right: 0;\r\n    left: 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.right-slider .slider-content {\r\n    padding: 1rem;\r\n    bottom: 5rem;\r\n    width: 20rem;\r\n    flex: 1;\r\n    overflow-y: auto;\r\n}\r\n\r\n.right-slider .slider-footer {\r\n    width: 100%;\r\n    padding: 1rem;\r\n}\r\n\r\n.right-slider .slider-footer .btn {\r\n    width: 100%;\r\n}\r\n\r\n.right-slider.active {\r\n    right: 0;\r\n}\r\n\r\n.btn-slide-closer {\r\n    font-weight: bolder;\r\n    font-size: 1.5rem;\r\n    color: #55595c;\r\n    position: absolute;\r\n    top: 0;\r\n    right: 20rem;\r\n    background-color: #fff;\r\n    padding: .5rem .75rem;\r\n    border-radius: 0 0 0 .5rem;\r\n}\r\n\r\n@media (min-width: 1025px) {\r\n    .slider-background {\r\n        display: none !important;\r\n    }\r\n}\r\n\r\n\r\n.customer-search {\r\n    position: relative;\r\n}\r\n\r\n.btn-create-customer .btn-content {\r\n    background-color: white;\r\n}\r\n\r\n.input-field + .search-field {\r\n    margin-top: 1rem;\r\n}\r\n\r\n.search-field {\r\n    position: relative;\r\n}\r\n\r\n.search-dropdown-header-container {\r\n    padding:.5rem .5rem .25rem 1rem;\r\n    border-bottom: 1px solid #efefef;\r\n    margin-bottom: .5rem;\r\n}\r\n\r\n.search-dropdown .search-results {\r\n    max-height: 29rem;\r\n    overflow: auto;\r\n}\r\n\r\n.search-dropdown .search-results .disabled {\r\n    color: #ccc;\r\n}\r\n\r\n.search-field.no-label label {\r\n    display: none;\r\n}\r\n\r\n.search-field .input-field {\r\n    margin-top: 0;\r\n}\r\n\r\n.search-field span.invalid {\r\n    font-size: .8rem;\r\n}\r\n\r\n.search-field.active input {\r\n    border-bottom: 1px solid #eee;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n}\r\n\r\n.search-field.invalid:not(.active) input {\r\n    border-color: red;\r\n}\r\n\r\n.search-field .search-dropdown {\r\n    font-size: .75rem;\r\n    display: none;\r\n    background-color: #fff;\r\n    border: 1px solid #3BAFDA;\r\n    border-bottom: 1px solid #eee;\r\n    border-bottom-right-radius: 0.22rem;\r\n    border-bottom-left-radius: 0.22rem;\r\n    position: absolute;\r\n    width: 100%;\r\n    z-index: 1001;\r\n    top: 2rem;\r\n}\r\n\r\n.search-field:not(.no-label):not(.inline-label) .search-dropdown {\r\n    top: calc(3rem + 4px);\r\n}\r\n\r\n.search-field.no-label .search-dropdown {\r\n    border-top: 1px solid #ccc;\r\n}\r\n\r\n.grid-container .search-field .search-dropdown {\r\n    width: calc(100% - 2rem);\r\n}\r\n\r\n.search-field.active .search-dropdown {\r\n    display: block;\r\n}\r\n\r\n.search-field.focused .search-dropdown {\r\n    border-top-color: #DEDEDE;\r\n    border-right-color: #3BAFDA;\r\n    border-bottom-color: #3BAFDA;\r\n    border-left-color: #3BAFDA;\r\n}\r\n\r\n.search-field.invalid .search-dropdown {\r\n    border-right-color: red;\r\n    border-bottom-color: red;\r\n    border-left-color: red;\r\n}\r\n\r\n.search-field.focused input {\r\n    border-right-color: #3BAFDA;\r\n    border-top-color: #3BAFDA;\r\n    border-bottom-color: #3BAFDA;\r\n    border-left-color: #3BAFDA;\r\n}\r\n\r\n.search-field.focused.invalid input {\r\n    border-right-color: red;\r\n    border-top-color: red;\r\n    border-left-color: red;\r\n}\r\n\r\n.search-field .selected-results {\r\n    padding: 1rem;\r\n    font-size: .75rem;\r\n}\r\n\r\n.search-field .search-results ul {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.search-field .searching-label {\r\n    position: absolute;\r\n    right: 1rem;\r\n    top: 1.5rem;\r\n    z-index: 1002;\r\n}\r\n\r\n.grid-container .search-field .searching-label {\r\n    right: 2rem;\r\n}\r\n\r\n.search-field .search-results ul li {\r\n    padding: .5rem;\r\n    list-style: none;\r\n    cursor: pointer;\r\n    color: #3A4856;\r\n}\r\n\r\n.search-field .search-results ul li:first-of-type {\r\n    padding-top: 1rem;\r\n}\r\n\r\n.search-field .search-results ul li i {\r\n    margin-right: .5rem;\r\n    opacity: 0;\r\n    color: green;\r\n}\r\n\r\n.search-field .search-results ul li.selected {\r\n    font-weight: bold;\r\n}\r\n\r\n.search-field .search-results ul li.selected i {\r\n    opacity: 1;\r\n}\r\n\r\n.search-field-wrapper {\r\n    display:  flex;\r\n}\r\n\r\n.search-field-wrapper .search-field {\r\n    flex: 1;\r\n}\r\n\r\n.search-field-wrapper .btn {\r\n    height: 31.5px;\r\n    margin-top: 2.25rem;\r\n    margin-left: .5rem;\r\n}\r\n\r\n.width-100.search-field>.input-field {\r\n    width: 100%;\r\n}\r\n\r\n.user-profile-image-field {\r\n    text-align: center;\r\n}\r\n\r\n.user-profile-image-field .image-outer-wrapper {\r\n    position: relative;\r\n    max-width: 13rem;\r\n    margin: auto;\r\n}\r\n\r\n.user-profile-image-field .image-wrapper {\r\n    max-width: 13rem;\r\n    overflow: hidden;\r\n}\r\n\r\n.user-profile-image-field .profile-image {\r\n    height: 13rem;\r\n    font-size: 10rem;\r\n}\r\n\r\n.user-profile-image-field .croppie-wrapper {\r\n    width: 100%;\r\n}\r\n\r\n.user-profile-image-field .croppie-wrapper .croppie-container .cr-boundary {\r\n    height: 13rem;\r\n}\r\n\r\n.user-profile-image-field .croppie-wrapper .croppie-container .cr-slider-wrap {\r\n    margin-top: .25rem;\r\n    margin-bottom: 0;\r\n}\r\n\r\n.user-profile-image-field .btn-remove-data-item {\r\n    padding: 0;\r\n    top: -.5rem;\r\n    right: -.5rem;\r\n    position: absolute;\r\n}\r\n\r\n.image-container {\r\n    margin-top: .5rem;\r\n    display: flex;\r\n    flex-direction: column;\r\n    text-align: center;\r\n    min-height: 15rem;\r\n    position: relative;\r\n}\r\n\r\n.image-container img {\r\n    width: 100%;\r\n    margin-bottom: auto;\r\n}\r\n\r\n.image-container.deleted img {\r\n    opacity: .25;\r\n}\r\n\r\n.image-container .btn-remove-data-item {\r\n    top: 0rem;\r\n    right: 0rem;\r\n    position: absolute;\r\n    padding: 0;\r\n}\r\n\r\n\r\n/* Image Carousel */\r\n.image-carousel {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%\r\n}\r\n\r\n.image-carousel .active-image {\r\n    flex: 1;\r\n    margin: auto;\r\n    width: 100%;\r\n    display: flex;\r\n}\r\n\r\n.image-carousel .active-image .nav {\r\n    display: flex;\r\n    width: 5%;\r\n    height: 10rem;\r\n    margin: auto 0rem;\r\n}\r\n\r\n.image-carousel .active-image .nav .btn-nav {\r\n    font-size: 2rem;\r\n    height: 100%;\r\n    width: 100%;\r\n    display: flex;\r\n    color: #3A4856;\r\n}\r\n\r\n\r\n.image-carousel .active-image .nav .btn-nav i {\r\n    margin: auto;\r\n}\r\n\r\n.image-carousel .active-image .image-wrapper {\r\n    flex: 1;\r\n    display: flex;\r\n    margin: auto 0;\r\n}\r\n\r\n.image-carousel .active-image img {\r\n    margin: auto auto;\r\n    max-width: 90%;\r\n    width: auto;\r\n    max-height: calc(100vh - 25rem);\r\n    height: auto;\r\n    display: block;\r\n}\r\n\r\n.image-carousel-thumbnails {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.image-carousel-thumbnails img {\r\n    height: 4rem;\r\n    margin: .25rem;\r\n}\r\n\r\n\r\n/* Inventory Scheduler */\r\n.scheduler-timeline {\r\n    overflow-x: hidden;\r\n}\r\n\r\n.inventory-scheduler-row-wrapper {\r\n    border-top: 1px solid #ccc;\r\n    border-bottom: 1px solid #ccc;\r\n    margin-top: .25rem;\r\n    height: 2.5rem;\r\n}\r\n\r\n.scheduler-month-wrapper:first-of-type .inventory-scheduler-row-wrapper {\r\n    border-left: 1px solid #ccc;\r\n}\r\n\r\n.scheduler-month-wrapper:last-of-type .inventory-scheduler-row-wrapper {\r\n    border-right: 1px solid #ccc;\r\n}\r\n\r\n.inventory-scheduler-item-block {\r\n    border-left: 1px solid #ededed;\r\n    margin-right: -1px;\r\n    position: relative;\r\n}\r\n\r\n.scheduler-month-wrapper:first-of-type .inventory-scheduler-row-wrapper .inventory-scheduler-item-block:first-of-type {\r\n    border: none;\r\n}\r\n\r\n.pre-event {\r\n    background-color: #ccc;\r\n    border-color: transparent;\r\n    background-image:\r\n        repeating-linear-gradient(-45deg, black, #ddd 1px, transparent 1px, transparent 5px);\r\n}\r\n\r\n.event {\r\n    background-color: #ccc;\r\n    border-color: transparent;\r\n}\r\n\r\n.scheduler-event-info {\r\n    position: absolute;\r\n    white-space: nowrap;\r\n    top: .7rem;\r\n    left: .25rem;\r\n    font-weight: bold;\r\n    font-size: 85%;\r\n    z-index: 100;\r\n}\r\n\r\n.scheduler-event-info .btn {\r\n    text-decoration: underline;\r\n    color: #55595c;\r\n    font-size: .65rem;\r\n}\r\n\r\n.post-event {\r\n    background-color: #ccc;\r\n    border-color: transparent;\r\n    background-image:\r\n        repeating-linear-gradient(45deg, black, #ddd 1px, transparent 1px, transparent 5px);\r\n}\r\n\r\n.conflict {\r\n    background-color: red;\r\n    border-left-color: transparent;\r\n}\r\n\r\n.inventory-scheduler-request-header {\r\n    height: 2.5rem;\r\n    margin-top: .25rem;\r\n}\r\n\r\n.inventory-scheduler-request-header b {\r\n    margin: auto;\r\n}\r\n\r\n.inventory-scheduler-item-header .inventory-item-selction-check {\r\n    margin-left: -2rem;\r\n}\r\n\r\n.inventory-scheduler-item-header {\r\n    height: 2.5rem;\r\n    margin-top: .25rem;\r\n    padding-left: .5rem;\r\n    white-space: nowrap;\r\n}\r\n\r\n.inventory-scheduler-item-header .btn {\r\n    font-size: .8rem;\r\n}\r\n\r\n.inventory-scheduler-top-row {\r\n    height: 2.75rem;\r\n}\r\n\r\n.inventory-scheduler-vertical-spacer {\r\n    padding: .25rem;\r\n    text-align: center;\r\n    margin-top: 1.5rem;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.inventory-scheduler-vertical-spacer-header {\r\n    color: white;\r\n    background-color: #55595c;\r\n}\r\n\r\n.inventory-scheduler-empty-row i {\r\n    margin:auto;\r\n}\r\n\r\n.page-nav {\r\n    padding: 0 0 1rem 0;\r\n    margin: 0;\r\n    height: min-content;\r\n}\r\n\r\n.page-nav li {\r\n    list-style: none;\r\n}\r\n\r\n.page-nav li a {\r\n    padding: .5rem 1rem;\r\n}\r\n\r\n.confirmation-prompt {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 4rem;\r\n    padding: 4rem 1rem 0 1rem;\r\n    z-index: 900;\r\n    background: #f3f3f3;\r\n}\r\n\r\n.confirmation-prompt ~ * {\r\n    display: none;\r\n}\r\n\r\n@media (min-width: 1025px) {\r\n    .confirmation-prompt {\r\n        left: 16rem;\r\n    }\r\n}\r\n\r\n.page-heading {\r\n    display: flex;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.page-heading h1,\r\n.page-heading h2,\r\n.page-heading h3,\r\n.page-heading h4,\r\n.page-heading h5,\r\n.page-heading h6 {\r\n    margin: 0;\r\n}\r\n\r\n.page-heading .btn-container,\r\n.page-heading .btn-container,\r\n.page-heading .btn-container,\r\n.page-heading .btn-container,\r\n.page-heading .btn-container,\r\n.page-heading .btn-container {\r\n    margin-left: auto;\r\n    display: flex;\r\n}\r\n\r\n\r\n.date-field-calendar {\r\n    position: absolute;\r\n    background-color: #fff;\r\n    padding: .5rem;\r\n    width: 100%;\r\n    border: 1px solid #005377;\r\n    top: 3.25rem;\r\n    z-index: 1;\r\n    min-width: 16rem;\r\n}\r\n\r\n.date-field-calendar-header {\r\n    display: flex;\r\n    padding: .5rem 1rem;\r\n}\r\n\r\n.date-field-calendar-header-center {\r\n    text-align: center;\r\n    flex: 1;\r\n}\r\n\r\n.date-field-calendar-body {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin-top: .5rem;\r\n}\r\n\r\n.date-field-calendar-row {\r\n    flex: 1;\r\n    display: flex;\r\n}\r\n\r\n.date-field-calendar-row:first-of-type {\r\n    font-weight: bold;\r\n}\r\n\r\n.date-field-calendar-day {\r\n    flex: 1;\r\n    padding: .25rem;\r\n    text-align: center;\r\n}\r\n\r\n.date-field-calendar-footer {\r\n    padding: .5rem .5rem .25rem .5rem;\r\n    border-top: 1px solid #efefef;\r\n    margin-top: 0.5rem;\r\n    text-align: center;\r\n}\r\n\r\n.date-field-calendar-footer .btn {\r\n    font-size: .75rem;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n\r\n    .form-container .input-field,\r\n    .checkbox label {\r\n        font-size: .8rem;\r\n    }\r\n\r\n    .input-field:not(.radio) input, .input-field select, .input-field textarea {\r\n        font-size: .9rem;\r\n    }\r\n\r\n    .date-field-calendar {\r\n        max-width: 25rem;\r\n    }\r\n}\r\n\r\n@media (min-width: 575px) {\r\n    .sm-1 > .date-field-calendar,\r\n    .sm-2 > .date-field-calendar,\r\n    .sm-3 > .date-field-calendar,\r\n    .sm-4 > .date-field-calendar,\r\n    .sm-5 > .date-field-calendar,\r\n    .sm-6 > .date-field-calendar,\r\n    .sm-7 > .date-field-calendar,\r\n    .sm-8 > .date-field-calendar,\r\n    .sm-9 > .date-field-calendar,\r\n    .sm-10 > .date-field-calendar,\r\n    .sm-11 > .date-field-calendar,\r\n    .sm-12 > .date-field-calendar {\r\n        width: calc(100% - 2rem);\r\n    }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .md-1 > .date-field-calendar,\r\n    .md-2 > .date-field-calendar,\r\n    .md-3 > .date-field-calendar,\r\n    .md-4 > .date-field-calendar,\r\n    .md-5 > .date-field-calendar,\r\n    .md-6 > .date-field-calendar,\r\n    .md-7 > .date-field-calendar,\r\n    .md-8 > .date-field-calendar,\r\n    .md-9 > .date-field-calendar,\r\n    .md-10 > .date-field-calendar,\r\n    .md-11 > .date-field-calendar,\r\n    .md-12 > .date-field-calendar {\r\n        width: calc(100% - 2rem);\r\n    }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n    .lg-1 > .date-field-calendar,\r\n    .lg-2 > .date-field-calendar,\r\n    .lg-3 > .date-field-calendar,\r\n    .lg-4 > .date-field-calendar,\r\n    .lg-5 > .date-field-calendar,\r\n    .lg-6 > .date-field-calendar,\r\n    .lg-7 > .date-field-calendar,\r\n    .lg-8 > .date-field-calendar,\r\n    .lg-9 > .date-field-calendar,\r\n    .lg-10 > .date-field-calendar,\r\n    .lg-11 > .date-field-calendar,\r\n    .lg-12 > .date-field-calendar {\r\n        width: calc(100% - 2rem);\r\n    }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .xl-1 > .date-field-calendar,\r\n    .xl-2 > .date-field-calendar,\r\n    .xl-3 > .date-field-calendar,\r\n    .xl-4 > .date-field-calendar,\r\n    .xl-5 > .date-field-calendar,\r\n    .xl-6 > .date-field-calendar,\r\n    .xl-7 > .date-field-calendar,\r\n    .xl-8 > .date-field-calendar,\r\n    .xl-9 > .date-field-calendar,\r\n    .xl-10 > .date-field-calendar,\r\n    .xl-11 > .date-field-calendar,\r\n    .xl-12 > .date-field-calendar {\r\n        width: calc(100% - 2rem);\r\n    }\r\n}\r\n\r\n\r\n.user-profile-image {\r\n    width: 2rem;\r\n    height: 2rem;\r\n    border-radius: 50%;\r\n}\r\n\r\ni.user-avatar {\r\n    font-size: 2.5rem;\r\n}\r\n\r\nimg.user-avatar {\r\n    width: 2.5rem;\r\n    height: 2.5rem;\r\n}\r\n\r\n\r\n.loader, .loader:before, .loader:after {\r\n    background: transparent;\r\n    -webkit-animation: load1 1s infinite ease-in-out;\r\n    animation: load1 1s infinite ease-in-out;\r\n    width: .5rem;\r\n    height: 4rem;\r\n}\r\n\r\n.loader {\r\n    color: #ddd;\r\n    font-size: .5rem;\r\n    -webkit-transform: translateZ(0);\r\n    -ms-transform: translateZ(0);\r\n    transform: translateZ(0);\r\n    -webkit-animation-delay: -0.16s;\r\n    animation-delay: -0.16s;\r\n}\r\n\r\n.loader:before, .loader:after {\r\n    position: absolute;\r\n    top: 0;\r\n    content: '';\r\n}\r\n\r\n.loader:before {\r\n    left: -1.5em;\r\n    -webkit-animation-delay: -0.32s;\r\n    animation-delay: -0.32s;\r\n}\r\n\r\n.loader:after {\r\n    left: 1.5em;\r\n}\r\n\r\n.rich-text-editor {\r\n    background-color: #FFF;\r\n    border: 1px solid #d4d4d4;\r\n    width: 100%;\r\n    padding: .5rem;\r\n    border-radius: .22rem;\r\n    height: 15rem;\r\n    overflow: auto;\r\n}\r\n\r\n.rich-text-editor:focus {\r\n    color: #4E5154;\r\n    border-color: #3BAFDA;\r\n    outline: none;\r\n}\r\n\r\n.settings-terms-field .rich-text-editor {\r\n    height: 35rem;\r\n}\r\n\r\n@-webkit-keyframes load1 {\r\n  0%, 80%, 100% {\r\n    box-shadow: 0 0;\r\n    height: 4em;\r\n  }\r\n  40% {\r\n        box-shadow: 0 -2em;\r\n        height: 5em;\r\n    }\r\n}\r\n@keyframes load1 {\r\n    0%, 80%, 100% {\r\n        box-shadow: 0 0;\r\n        height: 4em;\r\n    }\r\n    40% {\r\n        box-shadow: 0 -2em;\r\n        height: 5em;\r\n    }\r\n}\r\n\r\n\r\n.header-logo-image-preview {\r\n    height: 4rem;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    background-size: 13rem auto;\r\n}\r\n\r\n.interactive-room-assigner {\r\n    font-size: 85%;\r\n}\r\n\r\n.interactive-room-assigner .time-column .time-slot > span {\r\n    padding: 0 .5rem;\r\n    margin: auto;\r\n}\r\n\r\n.interactive-room-assigner .time-column .time-slot:not(first-of-type),\r\n.interactive-room-assigner .venue .time-slot:not(first-of-type) {\r\n    border-top: 1px solid #CCC;\r\n    height: 48px;\r\n    display: flex;\r\n}\r\n\r\n.interactive-room-assigner .venue {\r\n    border-left: 1px solid;\r\n    flex: 1;\r\n    position: relative;\r\n}\r\n\r\n.interactive-room-assigner .venue .time-slot {\r\n    background-color: #fff;\r\n}\r\n\r\n.interactive-room-assigner .time-column .header,\r\n.interactive-room-assigner .venue .header {\r\n    font-weight: bold;\r\n    height: 32px;\r\n    border-bottom: 1px solid #333;\r\n    display: flex;\r\n}\r\n\r\n.interactive-room-assigner .time-column .header > span,\r\n.interactive-room-assigner .venue .header > span {\r\n    margin: auto;\r\n}\r\n.interactive-room-assigner .time-column .header.invert,\r\n.interactive-room-assigner .venue .header.invert {\r\n    background: #333;\r\n    color: #fff;\r\n}\r\n\r\n.interactive-room-assigner .venue.hover .time-slot {\r\n    background: #ededed;\r\n}\r\n\r\n.interactive-room-assigner .meeting {\r\n    background: #005377;\r\n    color: white;\r\n    cursor: move;\r\n    width: calc(100% - 2px);\r\n    position: absolute;\r\n    padding: 0 .25rem;\r\n    overflow: visible;\r\n    margin: 0 1px;\r\n    border-top: 1px solid #fff;\r\n}\r\n\r\n.interactive-room-assigner .meeting .meeting-label {\r\n    overflow: hidden;\r\n}\r\n\r\n.interactive-room-assigner .meeting a {\r\n    color: white;\r\n    font-size: .75rem;\r\n}\r\n\r\n.interactive-room-assigner .meeting .meeting-detail-container {\r\n    position: relative;\r\n}\r\n\r\n.interactive-room-assigner .meeting .meeting-detail {\r\n    position: absolute;\r\n    bottom: .25rem;\r\n    border: 1px solid #333;\r\n    background: #fff;\r\n    color: #333;\r\n    padding: 1rem;\r\n    min-width: 26rem;\r\n    right: -.25rem;\r\n    z-index: 1000;\r\n}\r\n\r\n.interactive-room-assigner .meeting .meeting-detail.open-right {\r\n    left: -.25rem;\r\n    right: unset;\r\n}\r\n\r\n.interactive-room-assigner .meeting .meeting-detail a {\r\n    color: #333;;\r\n}\r\n\r\n.interactive-room-assigner .meeting.working {\r\n    background: #EE964B;\r\n}\r\n\r\n.interactive-room-assigner .meeting.time-slot-1 {\r\n    top: calc(2rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-2 {\r\n    top: calc(3.5rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-3 {\r\n    top: calc(5rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-4 {\r\n    top: calc(6.5rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-5 {\r\n    top: calc(8rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-6 {\r\n    top: calc(9.5rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-7 {\r\n    top: calc(11rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-8 {\r\n    top: calc(12.5rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-9 {\r\n    top: calc(14rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-10 {\r\n    top: calc(15.5rem + 2px);\r\n}\r\n\r\n.interactive-room-assigner .meeting.time-slot-11 {\r\n    top: calc(17rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-12 {\r\n    top: calc(18.5rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-13 {\r\n    top: calc(20rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-14 {\r\n    top: calc(21.5rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-15 {\r\n    top: calc(23rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-16 {\r\n    top: calc(24.5rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-17 {\r\n    top: calc(26rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-18 {\r\n    top: calc(27.5rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-19 {\r\n    top: calc(29rem + 2px);\r\n}\r\n\r\n.interactive-room-assigner .meeting.time-slot-20 {\r\n    top: calc(30.5rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-21 {\r\n    top: calc(32rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-22 {\r\n    top: calc(33.5rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-23 {\r\n    top: calc(35rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-24 {\r\n    top: calc(36.5rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-25 {\r\n    top: calc(38rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-26 {\r\n    top: calc(39.5rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-27 {\r\n    top: calc(41rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-28 {\r\n    top: calc(42.5rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-29 {\r\n    top: calc(44rem + 2px);\r\n}\r\n\r\n.interactive-room-assigner .meeting.time-slot-30 {\r\n    top: calc(45.5rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-31 {\r\n    top: calc(47rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-32 {\r\n    top: calc(48.5rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-33 {\r\n    top: calc(50rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-34 {\r\n    top: calc(51.5rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-35 {\r\n    top: calc(53rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-36 {\r\n    top: calc(54.5rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-37 {\r\n    top: calc(56rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-38 {\r\n    top: calc(57.5rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-39 {\r\n    top: calc(59rem + 2px);\r\n}\r\n\r\n.interactive-room-assigner .meeting.time-slot-40 {\r\n    top: calc(60.5rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-41 {\r\n    top: calc(62rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-42 {\r\n    top: calc(63.5rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-43 {\r\n    top: calc(65rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-44 {\r\n    top: calc(66.5rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-45 {\r\n    top: calc(68rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-46 {\r\n    top: calc(69.5rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-47 {\r\n    top: calc(71rem + 2px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-48 {\r\n    top: calc(72.5rem + 2px);\r\n}\r\n\r\n.interactive-room-assigner .meeting.time-slot-count-1 {\r\n    height: calc(1.5rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-2 {\r\n    height: calc(3rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-3 {\r\n    height: calc(4.5rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-4 {\r\n    height: calc(6rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-5 {\r\n    height: calc(7.5rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-6 {\r\n    height: calc(9rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-7 {\r\n    height: calc(10.5rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-8 {\r\n    height: calc(12rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-9 {\r\n    height: calc(13.5rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-10 {\r\n    height: calc(15rem - 3px);\r\n}\r\n\r\n.interactive-room-assigner .meeting.time-slot-count-11 {\r\n    height: calc(16.5rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-12 {\r\n    height: calc(18rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-13 {\r\n    height: calc(19.5rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-14 {\r\n    height: calc(21rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-15 {\r\n    height: calc(22.5rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-16 {\r\n    height: calc(24rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-17 {\r\n    height: calc(25.5rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-18 {\r\n    height: calc(27rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-19 {\r\n    height: calc(28.5rem - 3px);\r\n}\r\n\r\n.interactive-room-assigner .meeting.time-slot-count-20 {\r\n    height: calc(30rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-21 {\r\n    height: calc(31.5rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-22 {\r\n    height: calc(33rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-23 {\r\n    height: calc(34.5rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-24 {\r\n    height: calc(36rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-25 {\r\n    height: calc(37.5rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-26 {\r\n    height: calc(39rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-27 {\r\n    height: calc(41.5rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-28 {\r\n    height: calc(42rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-29 {\r\n    height: calc(43.5rem - 3px);\r\n}\r\n\r\n.interactive-room-assigner .meeting.time-slot-count-30 {\r\n    height: calc(45rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-31 {\r\n    height: calc(46.5rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-32 {\r\n    height: calc(48rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-33 {\r\n    height: calc(49.5rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-34 {\r\n    height: calc(51rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-35 {\r\n    height: calc(52.5rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-36 {\r\n    height: calc(54rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-37 {\r\n    height: calc(55.5rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-38 {\r\n    height: calc(57rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-39 {\r\n    height: calc(58.5rem - 3px);\r\n}\r\n\r\n.interactive-room-assigner .meeting.time-slot-count-40 {\r\n    height: calc(60rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-41 {\r\n    height: calc(61.5rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-42 {\r\n    height: calc(63rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-43 {\r\n    height: calc(64.5rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-44 {\r\n    height: calc(66rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-45 {\r\n    height: calc(67.5rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-46 {\r\n    height: calc(69rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-47 {\r\n    height: calc(70.5rem - 3px);\r\n}\r\n.interactive-room-assigner .meeting.time-slot-count-48 {\r\n    height: calc(72rem - 3px);\r\n}\r\n\r\n.bold-label {\r\n    color: #005377;\r\n    font-weight: bold;\r\n}\r\n\r\n.input-field.rich-editor-template-placeholder-select {\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.input-field.rich-editor-template-placeholder-select label {\r\n    white-space: initial;\r\n}\r\n\r\n.blank-wrapper {\r\n    width: 100%;\r\n}\r\n\r\n.display-page-wrapper {\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.meeting-placard {\r\n    background-image: url(./img/meetingPlacardBackground.jpg);\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n    width: 100%;\r\n    height: 100%;\r\n    padding: 1rem;\r\n    color: #fff;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.meeting-placard hr {\r\n    border: .15rem solid #fff;\r\n    opacity: 1;\r\n    border-radius: 0;\r\n    color: #fff;\r\n    background-color: #fff;\r\n}\r\n\r\n.meeting-placard .venue-name {\r\n    font-size: 2rem;\r\n    text-align: center;\r\n}\r\n\r\n.meeting-placard .next-meeting-info {\r\n    text-align: right;\r\n    font-size: 2rem;\r\n}\r\n\r\n.meeting-placard .meeting-data {\r\n    font-size: 4em;\r\n    text-align: center;\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n}\r\n\r\n.meeting-placard .meeting-data .meeting-number {\r\n    font-size: 4rem;\r\n}\r\n\r\n.meeting-placard .meeting-data .meeting-time {\r\n    margin-top: .5rem;\r\n    font-size: 2.25rem;\r\n}\r\n\r\n.meeting-placard .meeting-data .meeting-name {\r\n    margin-top: .5rem;\r\n    font-size: 3rem;\r\n}\r\n\r\n.meeting-display {\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.display-page-wrapper .meeting-display-header {\r\n    background: #00004c;\r\n    color: white;\r\n    display: flex;\r\n    padding: .5rem;\r\n}\r\n\r\n.display-page-wrapper .meeting-display-header > div {\r\n    flex: 1;\r\n    font-size: 2.25rem;\r\n}\r\n\r\n.display-page-wrapper .meeting-display-header > span {\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n}\r\n\r\n\r\n.display-page-wrapper .meeting-display-content {\r\n    height: 100%;\r\n    display: flex;\r\n}\r\n\r\n.display-page-wrapper .meeting-display-header .meeting-display-time {\r\n    font-size: 2rem;\r\n    margin-left: .5rem;\r\n}\r\n\r\n.display-page-wrapper .meeting-display-content .meeting-display-list {\r\n    background: #333;\r\n    color: white;\r\n    height: 100%;\r\n    padding: 0 .5rem .5rem .5rem;\r\n    border-top: 1px solid white;\r\n    width: 30rem;\r\n    min-width: 30rem;\r\n}\r\n\r\n.display-page-wrapper .meeting-display-content .meeting-display-list.full {\r\n    width: 100%;\r\n}\r\n\r\n.display-page-wrapper .meeting-display-content .meeting-display-list table {\r\n    border-spacing: 0;\r\n    width: 100%;\r\n}\r\n\r\n.display-page-wrapper .meeting-display-content .meeting-display-list table td,\r\n.display-page-wrapper .meeting-display-content .meeting-display-list table th {\r\n    padding: .5rem .5rem;\r\n}\r\n\r\n.display-page-wrapper .meeting-display-content .meeting-display-list table thead {\r\n    border-bottom: 2px solid white;\r\n}\r\n\r\n.display-page-wrapper .meeting-display-content .meeting-display-list table thead th {\r\n    border-bottom: 2px solid white;\r\n    text-align: center;\r\n}\r\n\r\n.display-page-wrapper .meeting-display-content .meeting-display-list table thead th:last-of-type {\r\n    text-align: left;\r\n}\r\n\r\n.display-page-wrapper .meeting-display-content .meeting-display-list table thead td:not(:last-of-type) {\r\n    border-bottom: 2px solid #ccc;\r\n    text-align: center;\r\n}\r\n\r\n.display-page-wrapper .meeting-display-content .meeting-display-grid {\r\n    overflow-x: auto;\r\n}\r\n\r\n.display-page-wrapper .meeting-display-content .meeting-display-grid table {\r\n    height: 100%;\r\n    border-spacing: 0;\r\n}\r\n\r\n.display-page-wrapper .meeting-display-content .meeting-display-grid th,\r\n.display-page-wrapper .meeting-display-content .meeting-display-grid td {\r\n    border: 1px solid #ccc;\r\n}\r\n\r\n.display-page-wrapper .meeting-display-content .meeting-display-grid .meeting-display-grid-time {\r\n    width: 100px;\r\n    min-width: 100px;\r\n    text-align: center;\r\n    padding: .5rem;\r\n}\r\n\r\n.display-page-wrapper .meeting-display-content .meeting-display-grid .meeting-container-cell {\r\n    position: relative;\r\n}\r\n\r\n.display-page-wrapper .meeting-display-content .meeting-display-grid .meeting-block {\r\n    display: flex;\r\n    background: #333;\r\n    border: 1px solid white;\r\n    border-radius: .5rem;\r\n    position: absolute;\r\n    color: white;\r\n    top: 0;\r\n    bottom: 0;\r\n}\r\n\r\n\r\n.pickup-label {\r\n    font-size: 0.7rem;\r\n    padding: 0 4px;\r\n    color: #666;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.display-page-wrapper .meeting-display-content .meeting-display-grid .meeting-block > span {\r\n    margin: auto;\r\n}\r\n\r\n.report-page .datagrid .datagrid-header {\r\n    display: flex;\r\n    font-weight: bold;\r\n    border-bottom: 2px solid #333;\r\n    height: 25px;\r\n}\r\n\r\n.report-page .datagrid .datagrid-header .datagrid-report-time-cell {\r\n    border: none;\r\n}\r\n\r\n.report-page .datagrid .datagrid-content {\r\n    display: flex;\r\n}\r\n\r\n.report-page .datagrid .datagrid-content .datagrid-report-time-cell-column {\r\n    width: 50px;\r\n    page-break-after: always;\r\n}\r\n\r\n.report-page .datagrid .datagrid-header .datagrid-column-header {\r\n    font-weight: bold;\r\n    flex: 1;\r\n    text-align: center;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n }\r\n\r\n.report-page .datagrid .datagrid-report-time-cell {\r\n    padding: 0;\r\n    width: 50px;\r\n    border: 1px solid #CCC;\r\n    border-top: none;\r\n    display: flex;\r\n}\r\n\r\n.report-page .datagrid .datagrid-report-time-cell span {\r\n    margin: auto;\r\n}\r\n\r\n.report-page .datagrid-report-items-column {\r\n    position: relative;\r\n    min-width: 150px;\r\n    padding: 0;\r\n    box-sizing: content-box;\r\n    vertical-align: top;\r\n    flex: 1;\r\n    border-right: 1px solid #ccc;\r\n}\r\n\r\n.report-page .datagrid-report-items-column .datagrid-report-items-cell {\r\n    border-bottom: 1px solid #ddd;\r\n    width: 100%;\r\n    display: block;\r\n}\r\n\r\n.report-page .datagrid-report-items-column .datagrid-report-item {\r\n    display: flex;\r\n    text-align: center;\r\n    position: absolute;\r\n    background: #CCC;\r\n    width: 100%;\r\n    border: 1px solid white;\r\n    border-right: none;\r\n    border-left: none;\r\n    overflow: hidden;\r\n}\r\n\r\n.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content * {\r\n    font-size: 10px !important;\r\n}\r\n\r\n.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content .datagrid-report-item-inner-content {\r\n    margin: auto 0;\r\n    max-height: 100%;\r\n    padding: 2px 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content .meeting-name {\r\n\r\n}\r\n\r\n.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content .meeting-details {\r\n    text-align: center;\r\n    width: 100%;\r\n    padding: 3px 0;\r\n}\r\n\r\n/* small */\r\n.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content.small {\r\n    line-height: 1;\r\n}\r\n\r\n.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content.small * {\r\n    font-size: 9px !important;\r\n}\r\n\r\n.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content.small .meeting-name {\r\n    overflow: hidden;\r\n}\r\n\r\n/* x-small */\r\n.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content.x-small {\r\n    line-height: 1;\r\n}\r\n\r\n.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content.x-small .datagrid-report-item-inner-content {\r\n    padding: 0;\r\n}\r\n\r\n.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content.x-small * {\r\n    font-size: 8px !important;\r\n}\r\n\r\n.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content.x-small .meeting-name {\r\n    overflow: hidden;\r\n}\r\n\r\n.report-page .datagrid-report-items-column .datagrid-report-item .datagrid-report-item-content.x-small .meeting-details {\r\n    padding: 0;\r\n}\r\n\r\n\r\n.report-page .profile-pic {\r\n    font-size: 3rem !important;\r\n    height: 3rem !important;\r\n}\r\n\r\n.note-disclaimer {\r\n    bottom: 5rem;\r\n    left: 0;\r\n    position: absolute;\r\n    padding: 1rem;\r\n}\r\n\r\n.cost-management-factor-breakdown .heading {\r\n    background-color: #337357;\r\n    font-weight: bold;\r\n    text-align: center;\r\n    color: white;\r\n}\r\n\r\n.cost-management-factor-breakdown .factor-breakdown-row > div {\r\n    border: 1px solid #AAA;\r\n    padding: 0 .25rem;\r\n}\r\n\r\n.non-removable-attendee-info + .non-removable-attendee-info {\r\n    padding-top: 1rem;\r\n    margin-top: 1rem;\r\n    border-top: 1px solid #AAA;\r\n}\r\n\r\n.video-button {\r\n    height: 1.5rem;\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n    margin-right: .5rem;\r\n    cursor: pointer;\r\n}\r\n\r\n.help-document-button {\r\n    height: 1.5rem;\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n    margin-right: .5rem;\r\n}\r\n\r\n.modal-video {\r\n    margin: auto;\r\n    width: 100%;\r\n    aspect-ratio: 16/9;\r\n    display: block;\r\n}\r\n\r\n.badging-table {\r\n    max-width: 40rem;\r\n}\r\n\r\n.PhoneInputCountry {\r\n    width: 4.5rem;\r\n}\r\n\r\n.PhoneInputCountryIcon {\r\n    box-shadow: none;\r\n}\r\n\r\n.PhoneInputCountryIcon > .country-selection-icon-wrapper {\r\n    position: relative;\r\n    width: 4.5rem;\r\n}\r\n\r\n.PhoneInputCountryIcon > .country-selection-icon-wrapper > img {\r\n    position: absolute;\r\n    top: -0.25rem;\r\n    width: 2rem;\r\n}\r\n\r\n.PhoneInputCountryIcon > .country-selection-icon-wrapper > span {\r\n    position: absolute;\r\n    top: -0.2rem;\r\n    right: 0;\r\n}\r\n\r\n.PhoneInputCountrySelectArrow {\r\n    margin-left: 1rem;\r\n}\r\n\r\n.editable-meeting-detail .modal-content .content {\r\n    height: calc(100% - 9rem);\r\n    overflow: auto;\r\n}\r\n\r\n\r\n\r\n/* Meeting Detail Modal */\r\n.editable-meeting-detail .modal-content .content {\r\n    padding: .5rem;\r\n    height: calc(100% - 14rem);\r\n    overflow: auto;\r\n    min-height: unset;\r\n    overflow-x: hidden;\r\n}\r\n\r\n.readonly-meeting-detail .modal-content {\r\n    background-color: #ECECEC;\r\n}\r\n\r\n.readonly-meeting-detail .modal-content .content {\r\n    padding: .5rem;\r\n    height: calc(100% - 14rem);\r\n    overflow: auto;\r\n    min-height: unset;\r\n    overflow-x: hidden;\r\n}\r\n\r\n.readonly-meeting-detail-section {\r\n    font-family: \"Muli\", Georgia, \"Times New Roman\", Times, serif;\r\n    background-color: #fefefe;\r\n    padding: .25rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.readonly-meeting-detail-section + .readonly-meeting-detail-label {\r\n    margin-top: .5rem;\r\n}\r\n\r\n.readonly-meeting-detail .readonly-meeting-detail-label {\r\n    font-size: .85rem;\r\n    font-weight: normal;\r\n    font-style: italic;\r\n    color: #005377;\r\n}\r\n\r\n.readonly-meeting-detail-section .readonly-meeting-detail-heading {\r\n    font-weight: normal;\r\n    margin-bottom: .5rem;\r\n}\r\n\r\n.readonly-meeting-detail-section i {\r\n    font-weight: normal;\r\n}\r\n\r\n.footer-tab-bar {\r\n    background: #005377;\r\n    height: 5rem;\r\n    padding: 0;\r\n    display: flex;\r\n    color: white;\r\n    justify-content: space-around;\r\n    flex: 1;\r\n}\r\n\r\n.footer-tab-bar > .dropdown-nav {\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n}\r\n\r\n.footer-tab-bar > a.btn,\r\n.footer-tab-bar  .dropdown-nav > a.btn {\r\n    color: white;\r\n    font-size: 1rem;\r\n}\r\n\r\n.footer-tab-bar > a.btn .btn-content > i:first-of-type,\r\n.footer-tab-bar > .dropdown-nav > a.btn .btn-content > i:first-of-type {\r\n    margin-bottom: .25rem;\r\n    font-size: 1.25rem;\r\n}\r\n\r\n.footer-tab-bar > .dropdown-nav .dropdown-wrapper .dropdown {\r\n    bottom: 3rem;\r\n    right: 0rem;\r\n}\r\n\r\n.meeting-detail-header-buttons > .dropdown-nav {\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n    margin-left: .5rem;\r\n    margin-right: .5rem;\r\n    display: flex;\r\n}\r\n\r\n.meeting-detail-header-buttons > .dropdown-nav .dropdown-wrapper .dropdown {\r\n    top: 2.5rem;\r\n    right: 0rem;\r\n}\r\n\r\n.meeting-detail-header-buttons > a.btn,\r\n.meeting-detail-header-buttons .dropdown-nav > a.btn {\r\n    font-size: .75rem;\r\n    margin-right: .5rem;\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n}\r\n\r\n\r\n.meeting-detail-header-buttons .dropdown-nav > a.btn {\r\n    color: white;\r\n}\r\n\r\n\r\n.meeting-detail-header-buttons a.btn .btn-content > i:first-of-type,\r\n.meeting-detail-header-buttons .dropdown-nav > a.btn .btn-content > i:first-of-type {\r\n    margin-bottom: .25rem;\r\n    font-size: 1rem;\r\n}\r\n\r\n.note-disclaimer {\r\n    bottom: 5rem;\r\n}\r\n\r\n.flex .h-spaced + .h-spaced {\r\n    margin-left: .5rem;\r\n}\r\n\r\n.flex .h-spaced:last-0f-type {\r\n    margin-left: 0;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .readonly-meeting-detail .modal-content .content {\r\n        height: calc(100% - 9rem);\r\n    }\r\n\r\n    .editable-meeting-detail .modal-content .content {\r\n        height: calc(100% - 9rem);\r\n    }\r\n\r\n    .modal-footer .h-5 {\r\n        height: calc(5rem - 1px);\r\n    }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .meeting-detail-header-buttons > .dropdown-nav .dropdown-wrapper .dropdown.open {\r\n        display: none !important;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
